/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigInt: { input: any; output: any };
  DateTime: { input: any; output: any };
  EmailAddress: { input: any; output: any };
  JSON: { input: any; output: any };
  JSONObject: { input: any; output: any };
  Long: { input: any; output: any };
  NegativeFloat: { input: any; output: any };
  NegativeInt: { input: any; output: any };
  NonNegativeFloat: { input: any; output: any };
  NonNegativeInt: { input: any; output: any };
  NonPositiveFloat: { input: any; output: any };
  NonPositiveInt: { input: any; output: any };
  PhoneNumber: { input: any; output: any };
  PositiveFloat: { input: any; output: any };
  PositiveInt: { input: any; output: any };
  PostalCode: { input: any; output: any };
  URL: { input: any; output: any };
  UnsignedFloat: { input: any; output: any };
  UnsignedInt: { input: any; output: any };
};

export type AcceptOfferContactInput = {
  _id: Scalars['ID']['input'];
  candidateAcceptOffer?: InputMaybe<Scalars['Boolean']['input']>;
  candidateTrainingStartPotentialDate?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type AcceptRejectContactInput = {
  _id: Scalars['ID']['input'];
  candidateAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  candidateRefusedFor?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type Affiliate = {
  __typename?: 'Affiliate';
  _id: Scalars['ID']['output'];
  affiliateId?: Maybe<Scalars['String']['output']>;
  parentUser?: Maybe<User>;
};

export type AffiliateUser = {
  __typename?: 'AffiliateUser';
  _id: Scalars['ID']['output'];
  affiliateId?: Maybe<Scalars['String']['output']>;
  parentAffiliateId?: Maybe<Scalars['String']['output']>;
  parentUserId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AffiliateUserAddress = {
  __typename?: 'AffiliateUserAddress';
  address?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AffiliateUserList = {
  __typename?: 'AffiliateUserList';
  items?: Maybe<Array<Maybe<AffiliateUser>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AffiliateUsersFilterInput = {
  parentAffiliateId?: InputMaybe<Scalars['String']['input']>;
};

export type Area = {
  __typename?: 'Area';
  geo?: Maybe<Geo>;
  name?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['Int']['output']>;
};

export type AreaInput = {
  geo?: InputMaybe<GeoInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['Int']['input']>;
};

export type AreaSearch = {
  __typename?: 'AreaSearch';
  _id: Scalars['ID']['output'];
  areas?: Maybe<Array<Maybe<Area>>>;
  remote?: Maybe<Scalars['Boolean']['output']>;
};

export type AreaSearchInput = {
  areas?: InputMaybe<Array<InputMaybe<AreaInput>>>;
  remote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AvailableProfile = {
  __typename?: 'AvailableProfile';
  _id: Scalars['ID']['output'];
  areaSearch?: Maybe<AreaSearch>;
  baseSalary?: Maybe<AvailableProfileBaseSalary>;
  bounty?: Maybe<Scalars['Float']['output']>;
  bountyChangedAt?: Maybe<Scalars['DateTime']['output']>;
  bountyDescription?: Maybe<Scalars['String']['output']>;
  bountyFinder?: Maybe<Scalars['Int']['output']>;
  bountySearcher?: Maybe<Scalars['Int']['output']>;
  candidate?: Maybe<Candidate>;
  client?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  context?: Maybe<Scalars['String']['output']>;
  countryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionUrl?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  job?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  matchings?: Maybe<Array<Maybe<Matching>>>;
  myMatchings?: Maybe<Array<Maybe<Matching>>>;
  name?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  occupationIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  occupations?: Maybe<Array<Maybe<Sector>>>;
  platformFees?: Maybe<Scalars['Float']['output']>;
  previousBounty?: Maybe<Scalars['Float']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  sectorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sectors?: Maybe<Array<Maybe<Sector>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AvailableProfileBaseSalary = {
  __typename?: 'AvailableProfileBaseSalary';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type AvailableProfileBaseSalaryInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailableProfileDetails = {
  __typename?: 'AvailableProfileDetails';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<AvailableProfile>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AvailableProfileList = {
  __typename?: 'AvailableProfileList';
  items?: Maybe<Array<Maybe<AvailableProfile>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AvailableProfilesFilterInput = {
  area?: InputMaybe<AreaInput>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  generalists?: InputMaybe<Scalars['Boolean']['input']>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  occupationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  q?: InputMaybe<Scalars['String']['input']>;
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Candidate = {
  __typename?: 'Candidate';
  _id?: Maybe<Scalars['ID']['output']>;
  availableProfiles?: Maybe<Array<Maybe<AvailableProfile>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  resumeUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CandidateList = {
  __typename?: 'CandidateList';
  items?: Maybe<Array<Maybe<Candidate>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CandidatesFilterInput = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type CompanySalaryTreated = {
  __typename?: 'CompanySalaryTreated';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type CompanySalaryTreatedInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type ConfirmTrainingContactInput = {
  _id: Scalars['ID']['input'];
  candidateConfirmTraining?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type Contact = {
  __typename?: 'Contact';
  _id?: Maybe<Scalars['ID']['output']>;
  aafConfirmUrl?: Maybe<Scalars['String']['output']>;
  aafStartUrl?: Maybe<Scalars['String']['output']>;
  availableProfile?: Maybe<AvailableProfile>;
  bountyConfirm?: Maybe<Scalars['Float']['output']>;
  bountyStart?: Maybe<Scalars['Float']['output']>;
  candidate?: Maybe<Candidate>;
  candidateAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateInProcessAt?: Maybe<Scalars['DateTime']['output']>;
  candidateNotInProcessAt?: Maybe<Scalars['DateTime']['output']>;
  candidateNotUnderOfferAt?: Maybe<Scalars['DateTime']['output']>;
  candidateOfferAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateOfferRefusedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateRefusedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateRefusedFor?: Maybe<Scalars['String']['output']>;
  candidateTrainingConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateTrainingConfirmedPotentialDate?: Maybe<Scalars['DateTime']['output']>;
  candidateTrainingNotConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateTrainingNotStartedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateTrainingStartPotentialDate?: Maybe<Scalars['DateTime']['output']>;
  candidateTrainingStartedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateUnderOfferAt?: Maybe<Scalars['DateTime']['output']>;
  contactInitiated?: Maybe<Scalars['Boolean']['output']>;
  contactStopped?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  currency?: Maybe<Scalars['String']['output']>;
  endedProcess?: Maybe<Scalars['Boolean']['output']>;
  events?: Maybe<Array<Maybe<ContactEvent>>>;
  inProcess?: Maybe<Scalars['Boolean']['output']>;
  invoiceConfirmWithCandidateId?: Maybe<Scalars['String']['output']>;
  invoiceConfirmWithMissionId?: Maybe<Scalars['String']['output']>;
  invoiceStartWithCandidateId?: Maybe<Scalars['String']['output']>;
  invoiceStartWithMissionId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  platformFees?: Maybe<Scalars['Float']['output']>;
  processConfirmed?: Maybe<Scalars['Boolean']['output']>;
  processSucceeded?: Maybe<Scalars['Boolean']['output']>;
  processSucceededAt?: Maybe<Scalars['DateTime']['output']>;
  rulesAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  rulesRefusedAt?: Maybe<Scalars['DateTime']['output']>;
  rulesRefusedFor?: Maybe<Scalars['String']['output']>;
  searchedProfile?: Maybe<SearchedProfile>;
  searcher?: Maybe<User>;
  shouldAnswerBefore?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContactCandidate = {
  __typename?: 'ContactCandidate';
  _id?: Maybe<Scalars['ID']['output']>;
  bountyConfirm?: Maybe<Scalars['Float']['output']>;
  bountyStart?: Maybe<Scalars['Float']['output']>;
  candidate?: Maybe<Candidate>;
  candidateAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateInProcessAt?: Maybe<Scalars['DateTime']['output']>;
  candidateNotInProcessAt?: Maybe<Scalars['DateTime']['output']>;
  candidateNotUnderOfferAt?: Maybe<Scalars['DateTime']['output']>;
  candidateOfferAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateOfferRefusedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateRefusedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateRefusedFor?: Maybe<Scalars['String']['output']>;
  candidateTrainingConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateTrainingNotConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateTrainingNotStartedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateTrainingStartedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateUnderOfferAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  currency?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<Maybe<ContactEvent>>>;
  platformFees?: Maybe<Scalars['Float']['output']>;
  rulesAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  rulesRefusedAt?: Maybe<Scalars['DateTime']['output']>;
  rulesRefusedFor?: Maybe<Scalars['String']['output']>;
  searchedProfile?: Maybe<SearchedProfile>;
  searcher?: Maybe<User>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContactCandidateInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  resumeUrl?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ContactCandidateList = {
  __typename?: 'ContactCandidateList';
  items?: Maybe<Array<Maybe<ContactCandidate>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactEvent = {
  __typename?: 'ContactEvent';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<ContactEventMetadata>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
};

export type ContactEventMetadata = {
  __typename?: 'ContactEventMetadata';
  message?: Maybe<Scalars['String']['output']>;
};

export type ContactInvoice = {
  __typename?: 'ContactInvoice';
  amount?: Maybe<Scalars['Int']['output']>;
  contact?: Maybe<Contact>;
  currency?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  from?: Maybe<User>;
  name?: Maybe<Scalars['String']['output']>;
  to?: Maybe<User>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ContactInvoicesFilterInput = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ContactInvoicesList = {
  __typename?: 'ContactInvoicesList';
  items?: Maybe<Array<Maybe<ContactInvoice>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactList = {
  __typename?: 'ContactList';
  items?: Maybe<Array<Maybe<Contact>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactMission = {
  __typename?: 'ContactMission';
  _id?: Maybe<Scalars['ID']['output']>;
  availableProfile?: Maybe<AvailableProfile>;
  bountyConfirm?: Maybe<Scalars['Float']['output']>;
  bountyStart?: Maybe<Scalars['Float']['output']>;
  candidate?: Maybe<Candidate>;
  candidateInProcessAt?: Maybe<Scalars['DateTime']['output']>;
  candidateNotInProcessAt?: Maybe<Scalars['DateTime']['output']>;
  candidateNotUnderOfferAt?: Maybe<Scalars['DateTime']['output']>;
  candidateOfferAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateOfferRefusedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateTrainingConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateTrainingNotConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateTrainingNotStartedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateTrainingStartedAt?: Maybe<Scalars['DateTime']['output']>;
  candidateUnderOfferAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  currency?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<Maybe<ContactEvent>>>;
  missionAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  missionRefusedAt?: Maybe<Scalars['DateTime']['output']>;
  platformFees?: Maybe<Scalars['Float']['output']>;
  rulesAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  rulesRefusedAt?: Maybe<Scalars['DateTime']['output']>;
  searcher?: Maybe<User>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContactMissionList = {
  __typename?: 'ContactMissionList';
  items?: Maybe<Array<Maybe<ContactMission>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactsFilterInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<ContactsListDirection>;
  progress?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  rsvp?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export enum ContactsListDirection {
  Received = 'RECEIVED',
  Sent = 'SENT',
}

export type CreateDiscussionInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  participantIds: Array<Scalars['ID']['input']>;
  type: DiscussionType;
};

export type CreateMessageInput = {
  content: Scalars['String']['input'];
  discussionId: Scalars['ID']['input'];
  metadata?: InputMaybe<MessageMetadataInput>;
  type?: InputMaybe<MessageType>;
};

export type DiscoverContactInput = {
  _id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  rulesAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  rulesRefusedFor?: InputMaybe<Scalars['String']['input']>;
};

export type Discussion = {
  __typename?: 'Discussion';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  lastMessage?: Maybe<LastMessage>;
  name?: Maybe<Scalars['String']['output']>;
  participantIds?: Maybe<Array<User>>;
  participants?: Maybe<Array<User>>;
  type?: Maybe<DiscussionType>;
  unreadCount?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DiscussionAndConnection = {
  __typename?: 'DiscussionAndConnection';
  connection?: Maybe<DiscussionConnection>;
  discussion?: Maybe<Discussion>;
};

export type DiscussionAndConnectionResponse = {
  __typename?: 'DiscussionAndConnectionResponse';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<DiscussionAndConnection>;
  success: Scalars['Boolean']['output'];
};

export type DiscussionConnection = {
  __typename?: 'DiscussionConnection';
  token?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DiscussionResponse = {
  __typename?: 'DiscussionResponse';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Discussion>;
  success: Scalars['Boolean']['output'];
};

export enum DiscussionType {
  Direct = 'direct',
  Group = 'group',
  Private = 'private',
}

export type DiscussionsFilterInput = {
  participantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DiscussionType>;
};

export type DiscussionsResponse = {
  __typename?: 'DiscussionsResponse';
  items: Array<Discussion>;
  pageInfo: PageInfo;
};

export type Event = {
  __typename?: 'Event';
  _id: Scalars['ID']['output'];
  author?: Maybe<Scalars['String']['output']>;
  authorUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nbMaxParticipants?: Maybe<Scalars['Int']['output']>;
  participants?: Maybe<Array<Maybe<EventParticipant>>>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  tool?: Maybe<Tool>;
  toolId: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type EventList = {
  __typename?: 'EventList';
  items?: Maybe<Array<Maybe<Event>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EventParticipant = {
  __typename?: 'EventParticipant';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eventId: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type EventParticipantList = {
  __typename?: 'EventParticipantList';
  items?: Maybe<Array<Maybe<EventParticipant>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EventParticipantsFilterInput = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type EventsFilterInput = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type Geo = {
  __typename?: 'Geo';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  coords?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GeoInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InProcessContactInput = {
  _id: Scalars['ID']['input'];
  candidateInProcess?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type InformContactInput = {
  _id: Scalars['ID']['input'];
  candidateInformed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  contact?: Maybe<Contact>;
  date: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  from: InvoiceAddress;
  header?: Maybe<Scalars['String']['output']>;
  lines: Array<InvoiceLine>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  to?: Maybe<InvoiceAddress>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type InvoiceAddress = {
  __typename?: 'InvoiceAddress';
  address?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type InvoiceAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceInput = {
  code: Scalars['String']['input'];
  date: Scalars['String']['input'];
  details?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  from: InvoiceAddressInput;
  header?: InputMaybe<Scalars['String']['input']>;
  lines: Array<InvoiceLineInput>;
  to: InvoiceAddressInput;
};

export type InvoiceLine = {
  __typename?: 'InvoiceLine';
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Float']['output'];
};

export type InvoiceLineInput = {
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  total: Scalars['Float']['input'];
};

export type InvoiceList = {
  __typename?: 'InvoiceList';
  items?: Maybe<Array<Maybe<Invoice>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type InvoicesFilterInput = {
  q?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type LastMessage = {
  __typename?: 'LastMessage';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  sender?: Maybe<User>;
  senderId?: Maybe<Scalars['ID']['output']>;
};

export type Location = {
  __typename?: 'Location';
  geo?: Maybe<Geo>;
  name?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
};

export type MarkAsReadResponse = {
  __typename?: 'MarkAsReadResponse';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MarkDiscussionAsReadInput = {
  discussionId: Scalars['ID']['input'];
};

export type MarkMessageAsReadInput = {
  messageId: Scalars['ID']['input'];
};

export type Matching = {
  __typename?: 'Matching';
  _id: Scalars['ID']['output'];
  availableProfile?: Maybe<AvailableProfile>;
  availableProfileId: Scalars['ID']['output'];
  availableProfileUserId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fromAvailableProfile?: Maybe<Scalars['Boolean']['output']>;
  fromSearchedProfile?: Maybe<Scalars['Boolean']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedByAvailableProfileUserAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedBySearchedProfileUserAt?: Maybe<Scalars['DateTime']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  searchedProfile?: Maybe<SearchedProfile>;
  searchedProfileId: Scalars['ID']['output'];
  searchedProfileUserId: Scalars['ID']['output'];
  sentToAvailableProfileUserByEmailAt?: Maybe<Scalars['DateTime']['output']>;
  sentToBrowserAt?: Maybe<Scalars['DateTime']['output']>;
  sentToSearchedProfileUserByEmailAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
  viewedByAvailableProfileUserAt?: Maybe<Scalars['DateTime']['output']>;
  viewedBySearchedProfileUserAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Message = {
  __typename?: 'Message';
  _id: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  discussionId: Scalars['ID']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  metadata?: Maybe<MessageMetadata>;
  readBy?: Maybe<Array<User>>;
  readByIds?: Maybe<Array<Scalars['ID']['output']>>;
  sender: User;
  senderId: Scalars['ID']['output'];
  type: MessageType;
  updatedAt: Scalars['DateTime']['output'];
};

export type MessageMetadata = {
  __typename?: 'MessageMetadata';
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  imageHeight?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageWidth?: Maybe<Scalars['Int']['output']>;
};

export type MessageMetadataInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  imageHeight?: InputMaybe<Scalars['Int']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  imageWidth?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Message>;
  success: Scalars['Boolean']['output'];
};

export enum MessageType {
  File = 'file',
  Image = 'image',
  System = 'system',
  Text = 'text',
}

export type MessagesFilterInput = {
  discussionId: Scalars['ID']['input'];
  q?: InputMaybe<Scalars['String']['input']>;
  senderId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<MessageType>;
};

export type MessagesResponse = {
  __typename?: 'MessagesResponse';
  items: Array<Message>;
  pageInfo: PageInfo;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptOfferContactCandidate?: Maybe<AcceptOfferContactCandidateOutput>;
  acceptRejectContactCandidate?: Maybe<AcceptRejectContactCandidateOutput>;
  archiveUser?: Maybe<UserDetailOutput>;
  confirmTrainingContactCandidate?: Maybe<ConfirmTrainingContactCandidateOutput>;
  createAvailableProfile?: Maybe<CreateAvailableProfileOutput>;
  createCandidate?: Maybe<CreateCandidateOutput>;
  createContact?: Maybe<CreateContactOutput>;
  createContactMission?: Maybe<CreateContactMissionOutput>;
  createDiscussion: DiscussionResponse;
  createEvent?: Maybe<CreateEventOutput>;
  createEventParticipant?: Maybe<CreateEventParticipantOutput>;
  createInvoice?: Maybe<CreateInvoiceOutput>;
  createMessage: MessageResponse;
  createNotification: CreateNotificationOutput;
  createProspect?: Maybe<CreateProspectOutput>;
  createSearchedProfile?: Maybe<CreateSearchedProfileOutput>;
  createSubscription?: Maybe<CreateSubscriptionOutput>;
  createTool?: Maybe<CreateToolOutput>;
  deleteAvailableProfile?: Maybe<DeleteAvailableProfileOutput>;
  deleteCandidate?: Maybe<DeleteCandidateOutput>;
  deleteContact?: Maybe<DeleteContactOutput>;
  deleteContactMission?: Maybe<DeleteContactMissionOutput>;
  deleteDiscussion: DiscussionResponse;
  deleteEvent?: Maybe<UpdateEventOutput>;
  deleteEventParticipant?: Maybe<DeleteEventParticipantOutput>;
  deleteInvoice?: Maybe<UpdateInvoiceOutput>;
  deleteMessage: MessageResponse;
  deleteSearchedProfile?: Maybe<DeleteSearchedProfileOutput>;
  deleteSubscription?: Maybe<DeleteSubscriptionOutput>;
  deleteTool?: Maybe<UpdateToolOutput>;
  discoverContactCandidate?: Maybe<DiscoverContactCandidateOutput>;
  discoverContactMission?: Maybe<DiscoverContactMissionOutput>;
  duplicateInvoice?: Maybe<DuplicateInvoiceOutput>;
  getBillingPortal?: Maybe<GetBillingPortalOutput>;
  giveExclusivitySearchedProfile?: Maybe<GiveExclusivitySearchedProfileOutput>;
  grantRole?: Maybe<UserDetailOutput>;
  impersonateUser?: Maybe<UserDetailOutput>;
  inProcessContactCandidate?: Maybe<InProcessContactCandidateOutput>;
  informContactCandidate?: Maybe<InformContactCandidateOutput>;
  markMessageAsRead: MarkAsReadResponse;
  proposeContactCandidate?: Maybe<ProposeContactCandidateOutput>;
  proposeContactMission?: Maybe<ProposeContactMissionOutput>;
  publishAvailableProfile?: Maybe<PublishAvailableProfileOutput>;
  publishSearchedProfile?: Maybe<PublishSearchedProfileOutput>;
  rejectMatching?: Maybe<RejectMatchingOutput>;
  removeRole?: Maybe<UserDetailOutput>;
  setParentAffiliate?: Maybe<SetParentAffiliateOutput>;
  startTrainingContactCandidate?: Maybe<StartTrainingContactCandidateOutput>;
  unarchiveUser?: Maybe<UserDetailOutput>;
  underOfferContactCandidate?: Maybe<UnderOfferContactCandidateOutput>;
  updateAAFInvoiceContact?: Maybe<UpdateAafInvoiceContactOutput>;
  updateAvailableProfile?: Maybe<UpdateAvailableProfileOutput>;
  updateCandidate?: Maybe<UpdateCandidateOutput>;
  updateContact?: Maybe<UpdateContactOutput>;
  updateContactStatus?: Maybe<UpdateContactStatusOutput>;
  updateDiscussion: DiscussionResponse;
  updateEvent?: Maybe<UpdateEventOutput>;
  updateEventParticipant?: Maybe<UpdateEventParticipantOutput>;
  updateInvoice?: Maybe<UpdateInvoiceOutput>;
  updateMessage: MessageResponse;
  updateMyInvoice?: Maybe<UpdateInvoiceOutput>;
  updateNotification: UpdateNotificationOutput;
  updateProspect?: Maybe<UpdateProspectOutput>;
  updateSearchedProfile?: Maybe<UpdateSearchedProfileOutput>;
  updateTool?: Maybe<UpdateToolOutput>;
  updateUser?: Maybe<UpdateUserOutput>;
  userNotifications?: Maybe<UserDetailOutput>;
  viewMatching?: Maybe<ViewMatchingOutput>;
};

export type MutationAcceptOfferContactCandidateArgs = {
  input: AcceptOfferContactCandidateInput;
};

export type MutationAcceptRejectContactCandidateArgs = {
  input: AcceptRejectContactCandidateInput;
};

export type MutationArchiveUserArgs = {
  input: ArchiveUserInput;
};

export type MutationConfirmTrainingContactCandidateArgs = {
  input: ConfirmTrainingContactCandidateInput;
};

export type MutationCreateAvailableProfileArgs = {
  input: CreateAvailableProfileInput;
};

export type MutationCreateCandidateArgs = {
  input: CreateCandidateInput;
};

export type MutationCreateContactArgs = {
  input: CreateContactInput;
};

export type MutationCreateContactMissionArgs = {
  input: CreateContactMissionInput;
};

export type MutationCreateDiscussionArgs = {
  input: CreateDiscussionInput;
};

export type MutationCreateEventArgs = {
  input: CreateEventInput;
};

export type MutationCreateEventParticipantArgs = {
  input: CreateEventParticipantInput;
};

export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};

export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};

export type MutationCreateNotificationArgs = {
  kind: NotificationKind;
  objectId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationCreateProspectArgs = {
  input: CreateProspectInput;
};

export type MutationCreateSearchedProfileArgs = {
  input: CreateSearchedProfileInput;
};

export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};

export type MutationCreateToolArgs = {
  input: CreateToolInput;
};

export type MutationDeleteAvailableProfileArgs = {
  _id: Scalars['ID']['input'];
};

export type MutationDeleteCandidateArgs = {
  _id: Scalars['ID']['input'];
};

export type MutationDeleteContactArgs = {
  _id: Scalars['ID']['input'];
};

export type MutationDeleteContactMissionArgs = {
  _id: Scalars['ID']['input'];
};

export type MutationDeleteDiscussionArgs = {
  _id: Scalars['ID']['input'];
};

export type MutationDeleteEventArgs = {
  _id: Scalars['ID']['input'];
};

export type MutationDeleteEventParticipantArgs = {
  _id: Scalars['ID']['input'];
};

export type MutationDeleteInvoiceArgs = {
  _id: Scalars['ID']['input'];
};

export type MutationDeleteMessageArgs = {
  _id: Scalars['ID']['input'];
};

export type MutationDeleteSearchedProfileArgs = {
  _id: Scalars['ID']['input'];
};

export type MutationDeleteSubscriptionArgs = {
  input: DeleteSubscriptionInput;
};

export type MutationDeleteToolArgs = {
  _id: Scalars['ID']['input'];
};

export type MutationDiscoverContactCandidateArgs = {
  input: DiscoverContactCandidateInput;
};

export type MutationDiscoverContactMissionArgs = {
  input: DiscoverContactMissionInput;
};

export type MutationDuplicateInvoiceArgs = {
  _id: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type MutationGetBillingPortalArgs = {
  input?: InputMaybe<GetBillingPortalInput>;
};

export type MutationGiveExclusivitySearchedProfileArgs = {
  _id: Scalars['ID']['input'];
  sourcingBy?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Boolean']['input'];
};

export type MutationGrantRoleArgs = {
  input: GrantRoleInput;
};

export type MutationImpersonateUserArgs = {
  input: ImpersonateUserInput;
};

export type MutationInProcessContactCandidateArgs = {
  input: InProcessContactCandidateInput;
};

export type MutationInformContactCandidateArgs = {
  input: InformContactCandidateInput;
};

export type MutationMarkMessageAsReadArgs = {
  input: MarkMessageAsReadInput;
};

export type MutationProposeContactCandidateArgs = {
  input: ProposeContactCandidateInput;
};

export type MutationProposeContactMissionArgs = {
  input: ProposeContactMissionInput;
};

export type MutationPublishAvailableProfileArgs = {
  _id: Scalars['ID']['input'];
  value: Scalars['Boolean']['input'];
};

export type MutationPublishSearchedProfileArgs = {
  _id: Scalars['ID']['input'];
  value: Scalars['Boolean']['input'];
};

export type MutationRejectMatchingArgs = {
  _id: Scalars['ID']['input'];
};

export type MutationRemoveRoleArgs = {
  input: RemoveRoleInput;
};

export type MutationSetParentAffiliateArgs = {
  input: SetParentAffiliateInput;
};

export type MutationStartTrainingContactCandidateArgs = {
  input: StartTrainingContactCandidateInput;
};

export type MutationUnarchiveUserArgs = {
  input: ArchiveUserInput;
};

export type MutationUnderOfferContactCandidateArgs = {
  input: UnderOfferContactCandidateInput;
};

export type MutationUpdateAafInvoiceContactArgs = {
  input: UpdateAafInvoiceContactInput;
};

export type MutationUpdateAvailableProfileArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateAvailableProfileInput;
};

export type MutationUpdateCandidateArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateCandidateInput;
};

export type MutationUpdateContactArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateContactInput;
};

export type MutationUpdateContactStatusArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateContactStatusInput;
};

export type MutationUpdateDiscussionArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateDiscussionInput;
};

export type MutationUpdateEventArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateEventInput;
};

export type MutationUpdateEventParticipantArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateEventParticipantInput;
};

export type MutationUpdateInvoiceArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateInvoiceInput;
};

export type MutationUpdateMessageArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateMessageInput;
};

export type MutationUpdateMyInvoiceArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateMyInvoiceInput;
};

export type MutationUpdateNotificationArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateNotificationInput;
};

export type MutationUpdateProspectArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateProspectInput;
};

export type MutationUpdateSearchedProfileArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateSearchedProfileInput;
};

export type MutationUpdateToolArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateToolInput;
};

export type MutationUpdateUserArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateUserInput;
};

export type MutationUserNotificationsArgs = {
  input: UserNotificationsInput;
};

export type MutationViewMatchingArgs = {
  _id: Scalars['ID']['input'];
};

export type Notification = {
  __typename?: 'Notification';
  _id?: Maybe<Scalars['ID']['output']>;
  availableProfile?: Maybe<AvailableProfile>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  kind?: Maybe<NotificationKind>;
  objectId?: Maybe<Scalars['ID']['output']>;
  searchedProfile?: Maybe<SearchedProfile>;
  sentByEmailAt?: Maybe<Scalars['DateTime']['output']>;
  sentToBrowserAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum NotificationKind {
  AvailableProfile = 'AvailableProfile',
  SearchedProfile = 'SearchedProfile',
}

export type NotificationList = {
  __typename?: 'NotificationList';
  items?: Maybe<Array<Maybe<Notification>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationsFilterInput = {
  viewedAt?: InputMaybe<Scalars['JSON']['input']>;
};

export type Occupation = {
  __typename?: 'Occupation';
  _id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OccupationList = {
  __typename?: 'OccupationList';
  items?: Maybe<Array<Maybe<Occupation>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  count?: Maybe<Scalars['NonNegativeInt']['output']>;
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['PositiveInt']['output']>;
  page?: Maybe<Scalars['PositiveInt']['output']>;
  startCursor?: Maybe<Scalars['ID']['output']>;
};

export type Plan = {
  __typename?: 'Plan';
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type ProposeContactInput = {
  _id: Scalars['ID']['input'];
  answerToDescription?: InputMaybe<Scalars['String']['input']>;
  candidateInformed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposeContactMissionInputInput = {
  _id: Scalars['ID']['input'];
  answerToDescription?: InputMaybe<Scalars['String']['input']>;
  bountyConfirm?: InputMaybe<Scalars['Float']['input']>;
  bountyStart?: InputMaybe<Scalars['Float']['input']>;
  rulesAccepted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Prospect = {
  __typename?: 'Prospect';
  _id: Scalars['ID']['output'];
  candidate?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  mission?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProspectList = {
  __typename?: 'ProspectList';
  items?: Maybe<Array<Maybe<Prospect>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PushSubscription = {
  __typename?: 'PushSubscription';
  endpoint: Scalars['String']['output'];
  expirationTime?: Maybe<Scalars['DateTime']['output']>;
  keys: PushSubscriptionKeys;
};

export type PushSubscriptionKeys = {
  __typename?: 'PushSubscriptionKeys';
  auth: Scalars['String']['output'];
  p256dh: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  affiliateUsers?: Maybe<AffiliateUserList>;
  availableProfile?: Maybe<AvailableProfileDetails>;
  availableProfiles?: Maybe<AvailableProfileList>;
  candidateContacts?: Maybe<ContactCandidateList>;
  candidates?: Maybe<CandidateList>;
  contactInvoices?: Maybe<ContactInvoicesList>;
  contacts?: Maybe<ContactList>;
  discussionAndConnection?: Maybe<DiscussionAndConnectionResponse>;
  discussions: DiscussionsResponse;
  eventParticipants?: Maybe<EventParticipantList>;
  events?: Maybe<EventList>;
  invoices?: Maybe<InvoiceList>;
  member?: Maybe<UserDetails>;
  members?: Maybe<UserList>;
  messages: MessagesResponse;
  missionContacts?: Maybe<ContactMissionList>;
  myAffiliateUsers?: Maybe<AffiliateUserList>;
  myAvailableProfiles?: Maybe<AvailableProfileList>;
  myContactInvoices?: Maybe<ContactInvoicesList>;
  myDiscussions: DiscussionsResponse;
  myInvoices?: Maybe<InvoiceList>;
  myNotifications: NotificationList;
  mySearchedProfiles?: Maybe<SearchedProfileList>;
  mySubscription?: Maybe<MySubscriptionOutput>;
  occupations?: Maybe<OccupationList>;
  prospects?: Maybe<ProspectList>;
  recruiters?: Maybe<UserList>;
  searchedProfile?: Maybe<SearchedProfileDetails>;
  searchedProfiles?: Maybe<SearchedProfileList>;
  sectors?: Maybe<SectorList>;
  tools?: Maybe<ToolList>;
  unreadCount: UnreadCountResponse;
  user?: Maybe<UserDetails>;
  users?: Maybe<UserList>;
};

export type QueryAffiliateUsersArgs = {
  filter?: InputMaybe<AffiliateUsersFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAvailableProfileArgs = {
  _id: Scalars['ID']['input'];
};

export type QueryAvailableProfilesArgs = {
  filter?: InputMaybe<AvailableProfilesFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCandidateContactsArgs = {
  filter?: InputMaybe<ContactsFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCandidatesArgs = {
  filter?: InputMaybe<CandidatesFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryContactInvoicesArgs = {
  filter?: InputMaybe<ContactInvoicesFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryContactsArgs = {
  filter?: InputMaybe<ContactsFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDiscussionAndConnectionArgs = {
  _id: Scalars['ID']['input'];
};

export type QueryDiscussionsArgs = {
  filter?: InputMaybe<DiscussionsFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEventParticipantsArgs = {
  filter?: InputMaybe<EventParticipantsFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEventsArgs = {
  filter?: InputMaybe<EventsFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryInvoicesArgs = {
  filter?: InputMaybe<InvoicesFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMemberArgs = {
  _id: Scalars['ID']['input'];
};

export type QueryMembersArgs = {
  filter?: InputMaybe<UsersFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMessagesArgs = {
  filter?: InputMaybe<MessagesFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMissionContactsArgs = {
  filter?: InputMaybe<ContactsFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMyAffiliateUsersArgs = {
  filter?: InputMaybe<AffiliateUsersFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMyAvailableProfilesArgs = {
  filter?: InputMaybe<AvailableProfilesFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMyContactInvoicesArgs = {
  filter?: InputMaybe<ContactInvoicesFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMyDiscussionsArgs = {
  filter?: InputMaybe<DiscussionsFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMyInvoicesArgs = {
  filter?: InputMaybe<InvoicesFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMyNotificationsArgs = {
  filter?: InputMaybe<NotificationsFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMySearchedProfilesArgs = {
  filter?: InputMaybe<SearchedProfilesFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOccupationsArgs = {
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProspectsArgs = {
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRecruitersArgs = {
  filter?: InputMaybe<UsersFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySearchedProfileArgs = {
  _id: Scalars['ID']['input'];
};

export type QuerySearchedProfilesArgs = {
  filter?: InputMaybe<SearchedProfilesFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySectorsArgs = {
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryToolsArgs = {
  filter?: InputMaybe<ToolsFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUserArgs = {
  _id: Scalars['ID']['input'];
};

export type QueryUsersArgs = {
  filter?: InputMaybe<UsersFilterInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type RecruiterTool = {
  __typename?: 'RecruiterTool';
  _id: Scalars['ID']['output'];
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  faviconUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SearchedProfile = {
  __typename?: 'SearchedProfile';
  _id: Scalars['ID']['output'];
  baseSalary?: Maybe<SearchedProfileBaseSalary>;
  bounty?: Maybe<Scalars['Float']['output']>;
  bountyChangedAt?: Maybe<Scalars['DateTime']['output']>;
  bountyConfirm?: Maybe<Scalars['Float']['output']>;
  bountyDescription?: Maybe<Scalars['String']['output']>;
  bountyStart?: Maybe<Scalars['Float']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  clientDisclosure?: Maybe<Scalars['Boolean']['output']>;
  commissionRate?: Maybe<Scalars['Float']['output']>;
  commissionRateDisclosure?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  context?: Maybe<Scalars['String']['output']>;
  countryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionUrl?: Maybe<Scalars['String']['output']>;
  exclusiveSourcer?: Maybe<User>;
  experience?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  fromPlatform?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  matchings?: Maybe<Array<Maybe<Matching>>>;
  myMatchings?: Maybe<Array<Maybe<Matching>>>;
  name?: Maybe<Scalars['String']['output']>;
  nbPositions?: Maybe<Scalars['Int']['output']>;
  nbPositionsFilled?: Maybe<Scalars['Int']['output']>;
  occupation?: Maybe<Occupation>;
  occupationId?: Maybe<Scalars['String']['output']>;
  platformFees?: Maybe<Scalars['Float']['output']>;
  previousBounty?: Maybe<Scalars['Float']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  sectorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sectors?: Maybe<Array<Maybe<Sector>>>;
  sites?: Maybe<AreaSearch>;
  sourcingAt?: Maybe<Scalars['DateTime']['output']>;
  sourcingBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  urgent?: Maybe<Scalars['Boolean']['output']>;
};

export type SearchedProfileBaseSalary = {
  __typename?: 'SearchedProfileBaseSalary';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type SearchedProfileBaseSalaryInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchedProfileDetails = {
  __typename?: 'SearchedProfileDetails';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<SearchedProfile>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SearchedProfileList = {
  __typename?: 'SearchedProfileList';
  items?: Maybe<Array<Maybe<SearchedProfile>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SearchedProfilesFilterInput = {
  area?: InputMaybe<AreaInput>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  myExcluSourcing?: InputMaybe<Scalars['Boolean']['input']>;
  occupationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  q?: InputMaybe<Scalars['String']['input']>;
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Sector = {
  __typename?: 'Sector';
  _id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SectorList = {
  __typename?: 'SectorList';
  items?: Maybe<Array<Maybe<Sector>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StartTrainingContactInput = {
  _id: Scalars['ID']['input'];
  candidateStartTraining?: InputMaybe<Scalars['Boolean']['input']>;
  candidateTrainingConfirmedPotentialDate?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type StripePlan = {
  __typename?: 'StripePlan';
  active?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amount_decimal?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  product?: Maybe<StripeProduct>;
  productName?: Maybe<Scalars['String']['output']>;
  usage_type?: Maybe<Scalars['String']['output']>;
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  active?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unit_label?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  cancel_at_period_end?: Maybe<Scalars['Boolean']['output']>;
  canceled_at?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  current_period_end?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  plan?: Maybe<StripePlan>;
  status?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StripeSubscriptionList = {
  __typename?: 'StripeSubscriptionList';
  items?: Maybe<Array<Maybe<StripeSubscription>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type Subscription = {
  __typename?: 'Subscription';
  plans?: Maybe<Array<Maybe<Plan>>>;
};

export type Tool = {
  __typename?: 'Tool';
  _id: Scalars['ID']['output'];
  author?: Maybe<Scalars['String']['output']>;
  authorUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nbMaxParticipants?: Maybe<Scalars['Int']['output']>;
  permissions?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  priceId?: Maybe<Scalars['String']['output']>;
  priceType?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ToolList = {
  __typename?: 'ToolList';
  items?: Maybe<Array<Maybe<Tool>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ToolsFilterInput = {
  q?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UnderOfferContactInput = {
  _id: Scalars['ID']['input'];
  candidateUnderOffer?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UnreadCountResponse = {
  __typename?: 'UnreadCountResponse';
  discussions: Array<Discussion>;
  totalUnread: Scalars['Int']['output'];
};

export type UpdateAafInvoiceContactInputInput = {
  _id: Scalars['ID']['input'];
  aafConfirmUrl?: InputMaybe<Scalars['String']['input']>;
  aafStartUrl?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDiscussionInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  participantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<MessageMetadataInput>;
  type?: InputMaybe<MessageType>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ID']['output'];
  affiliate?: Maybe<Affiliate>;
  ambassadorFor?: Maybe<Scalars['String']['output']>;
  areaSearch?: Maybe<AreaSearch>;
  behaviorGuidelines?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  businessAddress?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessRegistrationId?: Maybe<Scalars['String']['output']>;
  certificationIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  companyArea?: Maybe<Scalars['String']['output']>;
  companyClients?: Maybe<Scalars['String']['output']>;
  companyLocation?: Maybe<Scalars['String']['output']>;
  companySalaryTreated?: Maybe<CompanySalaryTreated>;
  companySize?: Maybe<Scalars['String']['output']>;
  countryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<UserFlags>;
  hasPendingActions?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  isTop?: Maybe<Scalars['Boolean']['output']>;
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<AreaSearch>;
  motivation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  motivation_other?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nbAvailableProfiles?: Maybe<Scalars['Int']['output']>;
  nbAvailableProfilesPublished?: Maybe<Scalars['Int']['output']>;
  nbContactsProspecting?: Maybe<Scalars['Int']['output']>;
  nbContactsSourcing?: Maybe<Scalars['Int']['output']>;
  nbQualityContactsProspecting?: Maybe<Scalars['Int']['output']>;
  nbQualityContactsSourcing?: Maybe<Scalars['Int']['output']>;
  nbSearchedProfiles?: Maybe<Scalars['Int']['output']>;
  nbSearchedProfilesPublished?: Maybe<Scalars['Int']['output']>;
  notifications?: Maybe<UserNotification>;
  occupation?: Maybe<Scalars['String']['output']>;
  occupationIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  occupations?: Maybe<Array<Maybe<Occupation>>>;
  onHolidays?: Maybe<Scalars['Boolean']['output']>;
  onHolidaysUntil?: Maybe<Scalars['DateTime']['output']>;
  openToSource?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<UserRating>;
  recruiterToolIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recruiterTools?: Maybe<Array<Maybe<RecruiterTool>>>;
  referrer?: Maybe<Scalars['String']['output']>;
  referrer_other?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sector?: Maybe<Scalars['String']['output']>;
  sectorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sectors?: Maybe<Array<Maybe<Sector>>>;
  strategy?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type UserDetailOutput = {
  __typename?: 'UserDetailOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<User>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UserDetails = {
  __typename?: 'UserDetails';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<User>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UserFlags = {
  __typename?: 'UserFlags';
  seenAreasAt?: Maybe<Scalars['DateTime']['output']>;
  seenBrowserNotificationsAt?: Maybe<Scalars['DateTime']['output']>;
  seenOccupationsAt?: Maybe<Scalars['DateTime']['output']>;
  seenSectorsAt?: Maybe<Scalars['DateTime']['output']>;
  sentToMakeAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserList = {
  __typename?: 'UserList';
  items?: Maybe<Array<Maybe<User>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UserNotification = {
  __typename?: 'UserNotification';
  browser?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  skipDailyEmail?: Maybe<Scalars['Boolean']['output']>;
  skipNewCandidates?: Maybe<Scalars['Boolean']['output']>;
  skipNewMissions?: Maybe<Scalars['Boolean']['output']>;
  subscriptions?: Maybe<Array<Maybe<PushSubscription>>>;
};

export type UserRating = {
  __typename?: 'UserRating';
  average?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  relevance?: Maybe<Scalars['Float']['output']>;
  reliability?: Maybe<Scalars['Float']['output']>;
  responsiveness?: Maybe<Scalars['Float']['output']>;
};

export enum UserRole {
  Archived = 'archived',
  Aspiring = 'aspiring',
  Booster = 'booster',
  Member = 'member',
  Pro = 'pro',
  Refused = 'refused',
  Starter = 'starter',
  Superadmin = 'superadmin',
  Teambooster = 'teambooster',
  Topmember = 'topmember',
}

export enum UserRoleFilter {
  Active = 'active',
  Archived = 'archived',
  Booster = 'booster',
  Company = 'company',
  Member = 'member',
  Pendingpayment = 'pendingpayment',
  Plus = 'plus',
  Pro = 'pro',
  Teambooster = 'teambooster',
  Toprevalidate = 'toprevalidate',
  Ultim = 'ultim',
  Vip = 'vip',
}

export type UsersFilterInput = {
  ambassadorFor?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<AreaInput>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  generalists?: InputMaybe<Scalars['Boolean']['input']>;
  occupationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openToSource?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRoleFilter>;
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AcceptOfferContactCandidateInput = {
  contact?: InputMaybe<AcceptOfferContactInput>;
};

export type AcceptOfferContactCandidateOutput = {
  __typename?: 'acceptOfferContactCandidateOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AcceptRejectContactCandidateInput = {
  contact?: InputMaybe<AcceptRejectContactInput>;
};

export type AcceptRejectContactCandidateOutput = {
  __typename?: 'acceptRejectContactCandidateOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ArchiveUserInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmTrainingContactCandidateInput = {
  contact?: InputMaybe<ConfirmTrainingContactInput>;
};

export type ConfirmTrainingContactCandidateOutput = {
  __typename?: 'confirmTrainingContactCandidateOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateAvailableProfileInput = {
  areaSearch?: InputMaybe<AreaSearchInput>;
  baseSalary?: InputMaybe<AvailableProfileBaseSalaryInput>;
  bounty?: InputMaybe<Scalars['Float']['input']>;
  bountyDescription?: InputMaybe<Scalars['String']['input']>;
  candidate: Scalars['ID']['input'];
  client?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['String']['input']>;
  job?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  occupationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateAvailableProfileOutput = {
  __typename?: 'createAvailableProfileOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<AvailableProfile>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCandidateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  resumeUrl?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCandidateOutput = {
  __typename?: 'createCandidateOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Candidate>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateContactInput = {
  searchedProfile?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactMissionInput = {
  availableProfile?: InputMaybe<Scalars['String']['input']>;
  candidate?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactMissionOutput = {
  __typename?: 'createContactMissionOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<ContactMission>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateContactOutput = {
  __typename?: 'createContactOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateEventInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endAt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['String']['input']>;
  toolId: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEventOutput = {
  __typename?: 'createEventOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Event>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateEventParticipantInput = {
  eventId: Scalars['ID']['input'];
};

export type CreateEventParticipantOutput = {
  __typename?: 'createEventParticipantOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<CreateEventParticipantOutputItem>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateEventParticipantOutputItem = {
  __typename?: 'createEventParticipantOutputItem';
  eventParticipant?: Maybe<EventParticipant>;
  paymentLink?: Maybe<Scalars['String']['output']>;
};

export type CreateInvoiceInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<Array<InputMaybe<InvoiceLineInput>>>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  to?: InputMaybe<InvoiceAddressInput>;
  userId: Scalars['String']['input'];
};

export type CreateInvoiceOutput = {
  __typename?: 'createInvoiceOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Invoice>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateNotificationOutput = {
  __typename?: 'createNotificationOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Notification>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateProspectInput = {
  candidate?: InputMaybe<Scalars['String']['input']>;
  mission?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProspectOutput = {
  __typename?: 'createProspectOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Prospect>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateSearchedProfileInput = {
  baseSalary?: InputMaybe<SearchedProfileBaseSalaryInput>;
  bountyConfirm?: InputMaybe<Scalars['Float']['input']>;
  bountyDescription?: InputMaybe<Scalars['String']['input']>;
  bountyStart?: InputMaybe<Scalars['Float']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  clientDisclosure?: InputMaybe<Scalars['Boolean']['input']>;
  commissionRate?: InputMaybe<Scalars['Float']['input']>;
  commissionRateDisclosure?: InputMaybe<Scalars['Boolean']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionUrl?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['String']['input']>;
  fromPlatform?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nbPositions?: InputMaybe<Scalars['Int']['input']>;
  occupationId?: InputMaybe<Scalars['String']['input']>;
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sites?: InputMaybe<AreaSearchInput>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateSearchedProfileOutput = {
  __typename?: 'createSearchedProfileOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<SearchedProfile>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateSubscriptionInput = {
  coupon?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubscriptionOutput = {
  __typename?: 'createSubscriptionOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<StripeSubscription>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateToolInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nbMaxParticipants?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateToolOutput = {
  __typename?: 'createToolOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Tool>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAvailableProfileOutput = {
  __typename?: 'deleteAvailableProfileOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<AvailableProfile>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCandidateOutput = {
  __typename?: 'deleteCandidateOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<SearchedProfile>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteContactMissionOutput = {
  __typename?: 'deleteContactMissionOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<ContactMission>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteContactOutput = {
  __typename?: 'deleteContactOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteEventParticipantOutput = {
  __typename?: 'deleteEventParticipantOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<EventParticipant>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteSearchedProfileOutput = {
  __typename?: 'deleteSearchedProfileOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<SearchedProfile>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteSubscriptionInput = {
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteSubscriptionOutput = {
  __typename?: 'deleteSubscriptionOutput';
  code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DiscoverContactCandidateInput = {
  contact?: InputMaybe<DiscoverContactInput>;
};

export type DiscoverContactCandidateOutput = {
  __typename?: 'discoverContactCandidateOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DiscoverContactMissionInput = {
  contact?: InputMaybe<DiscoverContactInput>;
};

export type DiscoverContactMissionOutput = {
  __typename?: 'discoverContactMissionOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DuplicateInvoiceOutput = {
  __typename?: 'duplicateInvoiceOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Invoice>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetBillingPortalInput = {
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GetBillingPortalOutput = {
  __typename?: 'getBillingPortalOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GiveExclusivitySearchedProfileOutput = {
  __typename?: 'giveExclusivitySearchedProfileOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<SearchedProfile>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GrantRoleInput = {
  role?: InputMaybe<UserRole>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ImpersonateUserInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type InProcessContactCandidateInput = {
  contact?: InputMaybe<InProcessContactInput>;
};

export type InProcessContactCandidateOutput = {
  __typename?: 'inProcessContactCandidateOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type InformContactCandidateInput = {
  contact?: InputMaybe<InformContactInput>;
};

export type InformContactCandidateOutput = {
  __typename?: 'informContactCandidateOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MySubscriptionOutput = {
  __typename?: 'mySubscriptionOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Subscription>;
  status?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ProposeContactCandidateInput = {
  candidate?: InputMaybe<ContactCandidateInput>;
  contact?: InputMaybe<ProposeContactInput>;
};

export type ProposeContactCandidateOutput = {
  __typename?: 'proposeContactCandidateOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ProposeContactMissionInput = {
  contact?: InputMaybe<ProposeContactMissionInputInput>;
};

export type ProposeContactMissionOutput = {
  __typename?: 'proposeContactMissionOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PublishAvailableProfileOutput = {
  __typename?: 'publishAvailableProfileOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<AvailableProfile>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PublishSearchedProfileOutput = {
  __typename?: 'publishSearchedProfileOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<SearchedProfile>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RejectMatchingOutput = {
  __typename?: 'rejectMatchingOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Matching>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveRoleInput = {
  role?: InputMaybe<UserRole>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SetParentAffiliateInput = {
  parentUserId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type SetParentAffiliateOutput = {
  __typename?: 'setParentAffiliateOutput';
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StartTrainingContactCandidateInput = {
  contact?: InputMaybe<StartTrainingContactInput>;
};

export type StartTrainingContactCandidateOutput = {
  __typename?: 'startTrainingContactCandidateOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UnderOfferContactCandidateInput = {
  contact?: InputMaybe<UnderOfferContactInput>;
};

export type UnderOfferContactCandidateOutput = {
  __typename?: 'underOfferContactCandidateOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAafInvoiceContactInput = {
  contact?: InputMaybe<UpdateAafInvoiceContactInputInput>;
};

export type UpdateAafInvoiceContactOutput = {
  __typename?: 'updateAAFInvoiceContactOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAvailableProfileInput = {
  areaSearch?: InputMaybe<AreaSearchInput>;
  baseSalary?: InputMaybe<AvailableProfileBaseSalaryInput>;
  bounty?: InputMaybe<Scalars['Float']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionUrl?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['String']['input']>;
  job?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  occupationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateAvailableProfileOutput = {
  __typename?: 'updateAvailableProfileOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<AvailableProfile>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCandidateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  resumeUrl?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCandidateOutput = {
  __typename?: 'updateCandidateOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Candidate>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateContactInput = {
  candidateTrainingConfirmedPotentialDate?: InputMaybe<Scalars['DateTime']['input']>;
  candidateTrainingStartPotentialDate?: InputMaybe<Scalars['DateTime']['input']>;
  prolongateContactAnswer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateContactOutput = {
  __typename?: 'updateContactOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateContactStatusInput = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactStatusOutput = {
  __typename?: 'updateContactStatusOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateEventInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endAt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['String']['input']>;
  toolId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventOutput = {
  __typename?: 'updateEventOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Event>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateEventParticipantInput = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventParticipantOutput = {
  __typename?: 'updateEventParticipantOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<EventParticipant>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateInvoiceInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<InvoiceAddressInput>;
  header?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<Array<InputMaybe<InvoiceLineInput>>>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  to?: InputMaybe<InvoiceAddressInput>;
  userId: Scalars['String']['input'];
};

export type UpdateInvoiceOutput = {
  __typename?: 'updateInvoiceOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Invoice>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateMyInvoiceInput = {
  to?: InputMaybe<InvoiceAddressInput>;
};

export type UpdateNotificationInput = {
  viewedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateNotificationOutput = {
  __typename?: 'updateNotificationOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Notification>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateProspectInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProspectOutput = {
  __typename?: 'updateProspectOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Prospect>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateSearchedProfileInput = {
  baseSalary?: InputMaybe<SearchedProfileBaseSalaryInput>;
  bountyConfirm?: InputMaybe<Scalars['Float']['input']>;
  bountyDescription?: InputMaybe<Scalars['String']['input']>;
  bountyStart?: InputMaybe<Scalars['Float']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  clientDisclosure?: InputMaybe<Scalars['Boolean']['input']>;
  commissionRate?: InputMaybe<Scalars['Float']['input']>;
  commissionRateDisclosure?: InputMaybe<Scalars['Boolean']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionUrl?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['String']['input']>;
  fromPlatform?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nbPositions?: InputMaybe<Scalars['Int']['input']>;
  occupationId?: InputMaybe<Scalars['String']['input']>;
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sites?: InputMaybe<AreaSearchInput>;
  sourcingAt?: InputMaybe<Scalars['DateTime']['input']>;
  sourcingBy?: InputMaybe<Scalars['String']['input']>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSearchedProfileOutput = {
  __typename?: 'updateSearchedProfileOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<SearchedProfile>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateToolInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nbMaxParticipants?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateToolOutput = {
  __typename?: 'updateToolOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Tool>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateUserInput = {
  areaSearch?: InputMaybe<AreaSearchInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  businessRegistrationId?: InputMaybe<Scalars['String']['input']>;
  companyArea?: InputMaybe<Scalars['String']['input']>;
  companyClients?: InputMaybe<Scalars['String']['input']>;
  companyLocation?: InputMaybe<Scalars['String']['input']>;
  companySalaryTreated?: InputMaybe<CompanySalaryTreatedInput>;
  companySize?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasPendingActions?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<AreaSearchInput>;
  motivation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  motivation_other?: InputMaybe<Scalars['String']['input']>;
  occupationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  referrer_other?: InputMaybe<Scalars['String']['input']>;
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  strategy?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserOutput = {
  __typename?: 'updateUserOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<User>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UserNotificationsInput = {
  skipNewCandidates: Scalars['Boolean']['input'];
  skipNewMissions: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type ViewMatchingOutput = {
  __typename?: 'viewMatchingOutput';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Matching>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BannerMySearchedProfilesQueryVariables = Exact<{ [key: string]: never }>;

export type BannerMySearchedProfilesQuery = {
  __typename?: 'Query';
  mySearchedProfiles?: { __typename?: 'SearchedProfileList'; pageInfo?: { __typename?: 'PageInfo'; count?: any | null } | null } | null;
};

export type BannerMyAvailableProfilesQueryVariables = Exact<{ [key: string]: never }>;

export type BannerMyAvailableProfilesQuery = {
  __typename?: 'Query';
  myAvailableProfiles?: { __typename?: 'AvailableProfileList'; pageInfo?: { __typename?: 'PageInfo'; count?: any | null } | null } | null;
};

export type ViewMatchingMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;

export type ViewMatchingMutation = {
  __typename?: 'Mutation';
  viewMatching?: { __typename?: 'viewMatchingOutput'; item?: { __typename?: 'Matching'; _id: string } | null } | null;
};

export type RejectMatchingMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;

export type RejectMatchingMutation = {
  __typename?: 'Mutation';
  rejectMatching?: { __typename?: 'rejectMatchingOutput'; item?: { __typename?: 'Matching'; _id: string } | null } | null;
};

export type RecruitersListQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  filter?: InputMaybe<UsersFilterInput>;
}>;

export type RecruitersListQuery = {
  __typename?: 'Query';
  recruiters?: {
    __typename?: 'UserList';
    pageInfo?: {
      __typename?: 'PageInfo';
      count?: any | null;
      page?: any | null;
      limit?: any | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
      endCursor?: string | null;
    } | null;
    items?: Array<{
      __typename?: 'User';
      _id: string;
      name?: string | null;
      image?: string | null;
      email?: string | null;
      title?: string | null;
      url?: string | null;
      bio?: string | null;
      phone?: string | null;
      companyLocation?: string | null;
      countryIds?: Array<string | null> | null;
      sectorIds?: Array<string | null> | null;
      sector?: string | null;
      occupationIds?: Array<string | null> | null;
      occupation?: string | null;
      companyArea?: string | null;
      companyClients?: string | null;
      companySize?: string | null;
      businessRegistrationId?: string | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      isTop?: boolean | null;
      openToSource?: boolean | null;
      ambassadorFor?: string | null;
      nbSearchedProfiles?: number | null;
      nbAvailableProfiles?: number | null;
      nbSearchedProfilesPublished?: number | null;
      nbAvailableProfilesPublished?: number | null;
      nbContactsProspecting?: number | null;
      nbContactsSourcing?: number | null;
      nbQualityContactsProspecting?: number | null;
      nbQualityContactsSourcing?: number | null;
      lastLoginAt?: any | null;
      certificationIds?: Array<string | null> | null;
      sectors?: Array<{ __typename?: 'Sector'; _id?: string | null; name?: string | null } | null> | null;
      occupations?: Array<{ __typename?: 'Occupation'; _id?: string | null; name?: string | null } | null> | null;
      companySalaryTreated?: { __typename?: 'CompanySalaryTreated'; min?: number | null; max?: number | null } | null;
      areaSearch?: {
        __typename?: 'AreaSearch';
        areas?: Array<{
          __typename?: 'Area';
          name?: string | null;
          radius?: number | null;
          geo?: { __typename?: 'Geo'; type?: string | null; coordinates?: Array<number | null> | null } | null;
        } | null> | null;
      } | null;
      locations?: {
        __typename?: 'AreaSearch';
        areas?: Array<{
          __typename?: 'Area';
          name?: string | null;
          radius?: number | null;
          geo?: { __typename?: 'Geo'; type?: string | null; coordinates?: Array<number | null> | null } | null;
        } | null> | null;
      } | null;
      recruiterTools?: Array<{
        __typename?: 'RecruiterTool';
        _id: string;
        name?: string | null;
        faviconUrl?: string | null;
        url?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type AcceptRejectContactCandidateMutationVariables = Exact<{
  input: AcceptRejectContactCandidateInput;
}>;

export type AcceptRejectContactCandidateMutation = {
  __typename?: 'Mutation';
  acceptRejectContactCandidate?: {
    __typename?: 'acceptRejectContactCandidateOutput';
    item?: {
      __typename?: 'Contact';
      _id?: string | null;
      shouldAnswerBefore?: any | null;
      events?: Array<{
        __typename?: 'ContactEvent';
        _id?: string | null;
        name?: string | null;
        eventType?: string | null;
        createdAt?: any | null;
        metadata?: { __typename?: 'ContactEventMetadata'; message?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type AffiliateUsersQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  filter?: InputMaybe<AffiliateUsersFilterInput>;
}>;

export type AffiliateUsersQuery = {
  __typename?: 'Query';
  affiliateUsers?: {
    __typename?: 'AffiliateUserList';
    pageInfo?: {
      __typename?: 'PageInfo';
      count?: any | null;
      page?: any | null;
      limit?: any | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
      endCursor?: string | null;
    } | null;
    items?: Array<{
      __typename?: 'AffiliateUser';
      affiliateId?: string | null;
      userId?: string | null;
      parentAffiliateId?: string | null;
      user?: {
        __typename?: 'User';
        _id: string;
        name?: string | null;
        image?: string | null;
        email?: string | null;
        title?: string | null;
        url?: string | null;
        bio?: string | null;
        phone?: string | null;
        companyLocation?: string | null;
        countryIds?: Array<string | null> | null;
        sectorIds?: Array<string | null> | null;
        sector?: string | null;
        roles?: Array<string | null> | null;
        occupationIds?: Array<string | null> | null;
        occupation?: string | null;
        companyArea?: string | null;
        companyClients?: string | null;
        companySize?: string | null;
        businessRegistrationId?: string | null;
        createdAt?: any | null;
        updatedAt?: any | null;
        isTop?: boolean | null;
        openToSource?: boolean | null;
        ambassadorFor?: string | null;
        onHolidaysUntil?: any | null;
        onHolidays?: boolean | null;
        sectors?: Array<{ __typename?: 'Sector'; _id?: string | null; name?: string | null } | null> | null;
        occupations?: Array<{ __typename?: 'Occupation'; _id?: string | null; name?: string | null } | null> | null;
        companySalaryTreated?: { __typename?: 'CompanySalaryTreated'; min?: number | null; max?: number | null } | null;
        areaSearch?: {
          __typename?: 'AreaSearch';
          areas?: Array<{ __typename?: 'Area'; name?: string | null; radius?: number | null } | null> | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type AvailableProfileQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;

export type AvailableProfileQuery = {
  __typename?: 'Query';
  availableProfile?: {
    __typename?: 'AvailableProfileDetails';
    code?: string | null;
    error?: string | null;
    success?: boolean | null;
    item?: {
      __typename?: 'AvailableProfile';
      _id: string;
      name?: string | null;
      bounty?: number | null;
      bountySearcher?: number | null;
      bountyFinder?: number | null;
      bountyDescription?: string | null;
      platformFees?: number | null;
      sector?: string | null;
      sectorIds?: Array<string | null> | null;
      occupationIds?: Array<string | null> | null;
      occupation?: string | null;
      client?: string | null;
      location?: string | null;
      experience?: string | null;
      description?: string | null;
      context?: string | null;
      publishedAt?: any | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      countryIds?: Array<string | null> | null;
      currency?: string | null;
      sectors?: Array<{ __typename?: 'Sector'; _id?: string | null; name?: string | null } | null> | null;
      occupations?: Array<{ __typename?: 'Sector'; _id?: string | null; name?: string | null } | null> | null;
      baseSalary?: { __typename?: 'AvailableProfileBaseSalary'; min?: number | null; max?: number | null } | null;
      createdBy?: {
        __typename?: 'User';
        _id: string;
        name?: string | null;
        title?: string | null;
        image?: string | null;
        isTop?: boolean | null;
        roles?: Array<string | null> | null;
      } | null;
      areaSearch?: {
        __typename?: 'AreaSearch';
        areas?: Array<{ __typename?: 'Area'; name?: string | null; radius?: number | null } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type AcceptOfferContactCandidateMutationVariables = Exact<{
  input: AcceptOfferContactCandidateInput;
}>;

export type AcceptOfferContactCandidateMutation = {
  __typename?: 'Mutation';
  acceptOfferContactCandidate?: {
    __typename?: 'acceptOfferContactCandidateOutput';
    item?: {
      __typename?: 'Contact';
      _id?: string | null;
      candidateTrainingStartPotentialDate?: any | null;
      shouldAnswerBefore?: any | null;
      events?: Array<{
        __typename?: 'ContactEvent';
        _id?: string | null;
        name?: string | null;
        eventType?: string | null;
        createdAt?: any | null;
        metadata?: { __typename?: 'ContactEventMetadata'; message?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type ConfirmTrainingContactCandidateMutationVariables = Exact<{
  input: ConfirmTrainingContactCandidateInput;
}>;

export type ConfirmTrainingContactCandidateMutation = {
  __typename?: 'Mutation';
  confirmTrainingContactCandidate?: {
    __typename?: 'confirmTrainingContactCandidateOutput';
    item?: {
      __typename?: 'Contact';
      _id?: string | null;
      invoiceConfirmWithCandidateId?: string | null;
      invoiceConfirmWithMissionId?: string | null;
      candidateTrainingStartPotentialDate?: any | null;
      candidateTrainingConfirmedPotentialDate?: any | null;
      shouldAnswerBefore?: any | null;
      events?: Array<{
        __typename?: 'ContactEvent';
        _id?: string | null;
        name?: string | null;
        eventType?: string | null;
        createdAt?: any | null;
        metadata?: { __typename?: 'ContactEventMetadata'; message?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type InProcessContactCandidateMutationVariables = Exact<{
  input: InProcessContactCandidateInput;
}>;

export type InProcessContactCandidateMutation = {
  __typename?: 'Mutation';
  inProcessContactCandidate?: {
    __typename?: 'inProcessContactCandidateOutput';
    item?: {
      __typename?: 'Contact';
      _id?: string | null;
      shouldAnswerBefore?: any | null;
      events?: Array<{
        __typename?: 'ContactEvent';
        _id?: string | null;
        name?: string | null;
        eventType?: string | null;
        createdAt?: any | null;
        metadata?: { __typename?: 'ContactEventMetadata'; message?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type StartTrainingContactCandidateMutationVariables = Exact<{
  input: StartTrainingContactCandidateInput;
}>;

export type StartTrainingContactCandidateMutation = {
  __typename?: 'Mutation';
  startTrainingContactCandidate?: {
    __typename?: 'startTrainingContactCandidateOutput';
    item?: {
      __typename?: 'Contact';
      _id?: string | null;
      invoiceStartWithCandidateId?: string | null;
      invoiceStartWithMissionId?: string | null;
      candidateTrainingStartPotentialDate?: any | null;
      candidateTrainingConfirmedPotentialDate?: any | null;
      shouldAnswerBefore?: any | null;
      events?: Array<{
        __typename?: 'ContactEvent';
        _id?: string | null;
        name?: string | null;
        eventType?: string | null;
        createdAt?: any | null;
        metadata?: { __typename?: 'ContactEventMetadata'; message?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type UnderOfferContactCandidateMutationVariables = Exact<{
  input: UnderOfferContactCandidateInput;
}>;

export type UnderOfferContactCandidateMutation = {
  __typename?: 'Mutation';
  underOfferContactCandidate?: {
    __typename?: 'underOfferContactCandidateOutput';
    item?: {
      __typename?: 'Contact';
      _id?: string | null;
      shouldAnswerBefore?: any | null;
      candidateTrainingStartPotentialDate?: any | null;
      events?: Array<{
        __typename?: 'ContactEvent';
        _id?: string | null;
        name?: string | null;
        eventType?: string | null;
        createdAt?: any | null;
        metadata?: { __typename?: 'ContactEventMetadata'; message?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type ContactInvoiceFragmentFragment = {
  __typename?: 'ContactInvoice';
  name?: string | null;
  amount?: number | null;
  date?: any | null;
  url?: string | null;
  type?: string | null;
  contact?: { __typename?: 'Contact'; _id?: string | null; name?: string | null } | null;
  from?: { __typename?: 'User'; _id: string; name?: string | null; image?: string | null; title?: string | null } | null;
  to?: { __typename?: 'User'; _id: string; name?: string | null; image?: string | null; title?: string | null } | null;
} & { ' $fragmentName'?: 'ContactInvoiceFragmentFragment' };

export type ContactInvoiceListQueryVariables = Exact<{
  page: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  filter?: InputMaybe<ContactInvoicesFilterInput>;
}>;

export type ContactInvoiceListQuery = {
  __typename?: 'Query';
  myContactInvoices?: {
    __typename?: 'ContactInvoicesList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null; page?: any | null; limit?: any | null } | null;
    items?: Array<
      ({ __typename?: 'ContactInvoice' } & { ' $fragmentRefs'?: { ContactInvoiceFragmentFragment: ContactInvoiceFragmentFragment } }) | null
    > | null;
  } | null;
};

export type DiscoverContactCandidateMutationVariables = Exact<{
  input: DiscoverContactCandidateInput;
}>;

export type DiscoverContactCandidateMutation = {
  __typename?: 'Mutation';
  discoverContactCandidate?: {
    __typename?: 'discoverContactCandidateOutput';
    item?: {
      __typename?: 'Contact';
      _id?: string | null;
      shouldAnswerBefore?: any | null;
      events?: Array<{
        __typename?: 'ContactEvent';
        _id?: string | null;
        name?: string | null;
        eventType?: string | null;
        createdAt?: any | null;
        metadata?: { __typename?: 'ContactEventMetadata'; message?: string | null } | null;
      } | null> | null;
      candidate?: {
        __typename?: 'Candidate';
        _id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phone?: string | null;
        email?: string | null;
        url?: string | null;
        resumeUrl?: string | null;
      } | null;
    } | null;
  } | null;
};

export type DiscoverContactMissionMutationVariables = Exact<{
  input: DiscoverContactMissionInput;
}>;

export type DiscoverContactMissionMutation = {
  __typename?: 'Mutation';
  discoverContactMission?: {
    __typename?: 'discoverContactMissionOutput';
    item?: {
      __typename?: 'Contact';
      _id?: string | null;
      shouldAnswerBefore?: any | null;
      events?: Array<{
        __typename?: 'ContactEvent';
        _id?: string | null;
        name?: string | null;
        eventType?: string | null;
        createdAt?: any | null;
        metadata?: { __typename?: 'ContactEventMetadata'; message?: string | null } | null;
      } | null> | null;
      candidate?: {
        __typename?: 'Candidate';
        _id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phone?: string | null;
        email?: string | null;
        url?: string | null;
        resumeUrl?: string | null;
      } | null;
    } | null;
  } | null;
};

export type AdminEventFieldsFragment = {
  __typename?: 'Event';
  _id: string;
  duration?: number | null;
  startAt?: any | null;
  endAt?: any | null;
  name?: string | null;
  url?: string | null;
  author?: string | null;
  authorUrl?: string | null;
  description?: string | null;
  tool?: {
    __typename?: 'Tool';
    name?: string | null;
    author?: string | null;
    authorUrl?: string | null;
    description?: string | null;
    duration?: number | null;
    type?: string | null;
    price?: number | null;
    priceId?: string | null;
    priceType?: string | null;
    permissions?: string | null;
    url?: string | null;
  } | null;
  participants?: Array<{
    __typename?: 'EventParticipant';
    _id: string;
    userId: string;
    status?: string | null;
    createdAt?: any | null;
  } | null> | null;
} & { ' $fragmentName'?: 'AdminEventFieldsFragment' };

export type EventCalendarQueryVariables = Exact<{ [key: string]: never }>;

export type EventCalendarQuery = {
  __typename?: 'Query';
  events?: {
    __typename?: 'EventList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null; page?: any | null; limit?: any | null } | null;
    items?: Array<({ __typename?: 'Event' } & { ' $fragmentRefs'?: { AdminEventFieldsFragment: AdminEventFieldsFragment } }) | null> | null;
  } | null;
};

export type InformContactCandidateMutationVariables = Exact<{
  input: InformContactCandidateInput;
}>;

export type InformContactCandidateMutation = {
  __typename?: 'Mutation';
  informContactCandidate?: {
    __typename?: 'informContactCandidateOutput';
    item?: {
      __typename?: 'Contact';
      _id?: string | null;
      events?: Array<{
        __typename?: 'ContactEvent';
        _id?: string | null;
        name?: string | null;
        eventType?: string | null;
        createdAt?: any | null;
        metadata?: { __typename?: 'ContactEventMetadata'; message?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type MemberQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;

export type MemberQuery = {
  __typename?: 'Query';
  member?: {
    __typename?: 'UserDetails';
    code?: string | null;
    error?: string | null;
    success?: boolean | null;
    item?: {
      __typename?: 'User';
      _id: string;
      name?: string | null;
      image?: string | null;
      email?: string | null;
      title?: string | null;
      url?: string | null;
      bio?: string | null;
      phone?: string | null;
      companyLocation?: string | null;
      sector?: string | null;
      companyArea?: string | null;
      roles?: Array<string | null> | null;
      companyClients?: string | null;
      companySize?: string | null;
      businessRegistrationId?: string | null;
      behaviorGuidelines?: string | null;
      nbAvailableProfiles?: number | null;
      nbAvailableProfilesPublished?: number | null;
      nbSearchedProfiles?: number | null;
      nbSearchedProfilesPublished?: number | null;
      nbContactsProspecting?: number | null;
      nbContactsSourcing?: number | null;
      nbQualityContactsProspecting?: number | null;
      nbQualityContactsSourcing?: number | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      lastLoginAt?: any | null;
      onHolidaysUntil?: any | null;
      onHolidays?: boolean | null;
      companySalaryTreated?: { __typename?: 'CompanySalaryTreated'; min?: number | null; max?: number | null } | null;
    } | null;
  } | null;
};

export type MemberListQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  filter?: InputMaybe<UsersFilterInput>;
}>;

export type MemberListQuery = {
  __typename?: 'Query';
  members?: {
    __typename?: 'UserList';
    pageInfo?: {
      __typename?: 'PageInfo';
      count?: any | null;
      page?: any | null;
      limit?: any | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
      endCursor?: string | null;
    } | null;
    items?: Array<{
      __typename?: 'User';
      _id: string;
      name?: string | null;
      image?: string | null;
      email?: string | null;
      title?: string | null;
      url?: string | null;
      bio?: string | null;
      phone?: string | null;
      companyLocation?: string | null;
      countryIds?: Array<string | null> | null;
      sectorIds?: Array<string | null> | null;
      sector?: string | null;
      occupationIds?: Array<string | null> | null;
      occupation?: string | null;
      companyArea?: string | null;
      companyClients?: string | null;
      companySize?: string | null;
      businessRegistrationId?: string | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      isTop?: boolean | null;
      roles?: Array<string | null> | null;
      openToSource?: boolean | null;
      ambassadorFor?: string | null;
      nbSearchedProfiles?: number | null;
      nbAvailableProfiles?: number | null;
      nbSearchedProfilesPublished?: number | null;
      nbAvailableProfilesPublished?: number | null;
      nbContactsProspecting?: number | null;
      nbContactsSourcing?: number | null;
      nbQualityContactsProspecting?: number | null;
      nbQualityContactsSourcing?: number | null;
      lastLoginAt?: any | null;
      onHolidaysUntil?: any | null;
      onHolidays?: boolean | null;
      certificationIds?: Array<string | null> | null;
      recruiterToolIds?: Array<string | null> | null;
      sectors?: Array<{ __typename?: 'Sector'; _id?: string | null; name?: string | null } | null> | null;
      occupations?: Array<{ __typename?: 'Occupation'; _id?: string | null; name?: string | null } | null> | null;
      companySalaryTreated?: { __typename?: 'CompanySalaryTreated'; min?: number | null; max?: number | null } | null;
      areaSearch?: {
        __typename?: 'AreaSearch';
        areas?: Array<{
          __typename?: 'Area';
          name?: string | null;
          radius?: number | null;
          geo?: { __typename?: 'Geo'; type?: string | null; coordinates?: Array<number | null> | null } | null;
        } | null> | null;
      } | null;
      locations?: {
        __typename?: 'AreaSearch';
        areas?: Array<{
          __typename?: 'Area';
          name?: string | null;
          radius?: number | null;
          geo?: { __typename?: 'Geo'; type?: string | null; coordinates?: Array<number | null> | null } | null;
        } | null> | null;
      } | null;
      recruiterTools?: Array<{
        __typename?: 'RecruiterTool';
        _id: string;
        name?: string | null;
        faviconUrl?: string | null;
        url?: string | null;
      } | null> | null;
      rating?: {
        __typename?: 'UserRating';
        average?: number | null;
        count?: number | null;
        responsiveness?: number | null;
        relevance?: number | null;
        reliability?: number | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ProposeContactCandidateMutationVariables = Exact<{
  input: ProposeContactCandidateInput;
}>;

export type ProposeContactCandidateMutation = {
  __typename?: 'Mutation';
  proposeContactCandidate?: {
    __typename?: 'proposeContactCandidateOutput';
    item?: {
      __typename?: 'Contact';
      _id?: string | null;
      shouldAnswerBefore?: any | null;
      events?: Array<{
        __typename?: 'ContactEvent';
        _id?: string | null;
        name?: string | null;
        eventType?: string | null;
        createdAt?: any | null;
        metadata?: { __typename?: 'ContactEventMetadata'; message?: string | null } | null;
      } | null> | null;
      candidate?: {
        __typename?: 'Candidate';
        _id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phone?: string | null;
        email?: string | null;
        url?: string | null;
      } | null;
    } | null;
  } | null;
};

export type ProposeCandidateQueryVariables = Exact<{ [key: string]: never }>;

export type ProposeCandidateQuery = {
  __typename?: 'Query';
  candidates?: {
    __typename?: 'CandidateList';
    pageInfo?: {
      __typename?: 'PageInfo';
      count?: any | null;
      page?: any | null;
      limit?: any | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
      endCursor?: string | null;
    } | null;
    items?: Array<{ __typename?: 'Candidate'; _id?: string | null; fullName?: string | null } | null> | null;
  } | null;
};

export type ProposeContactMissionMutationVariables = Exact<{
  input: ProposeContactMissionInput;
}>;

export type ProposeContactMissionMutation = {
  __typename?: 'Mutation';
  proposeContactMission?: {
    __typename?: 'proposeContactMissionOutput';
    item?: {
      __typename?: 'Contact';
      _id?: string | null;
      bountyStart?: number | null;
      bountyConfirm?: number | null;
      platformFees?: number | null;
      currency?: string | null;
      shouldAnswerBefore?: any | null;
      events?: Array<{
        __typename?: 'ContactEvent';
        _id?: string | null;
        name?: string | null;
        eventType?: string | null;
        createdAt?: any | null;
        metadata?: { __typename?: 'ContactEventMetadata'; message?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type SearchedProfileQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;

export type SearchedProfileQuery = {
  __typename?: 'Query';
  searchedProfile?: {
    __typename?: 'SearchedProfileDetails';
    code?: string | null;
    error?: string | null;
    success?: boolean | null;
    item?: {
      __typename?: 'SearchedProfile';
      _id: string;
      name?: string | null;
      bountyStart?: number | null;
      bountyDescription?: string | null;
      bountyConfirm?: number | null;
      platformFees?: number | null;
      sector?: string | null;
      sectorIds?: Array<string | null> | null;
      occupationId?: string | null;
      client?: string | null;
      location?: string | null;
      experience?: string | null;
      description?: string | null;
      descriptionUrl?: string | null;
      context?: string | null;
      fromPlatform?: string | null;
      sourcingAt?: any | null;
      sourcingBy?: string | null;
      publishedAt?: any | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      countryIds?: Array<string | null> | null;
      currency?: string | null;
      urgent?: boolean | null;
      commissionRate?: number | null;
      nbPositions?: number | null;
      nbPositionsFilled?: number | null;
      completedAt?: any | null;
      sectors?: Array<{ __typename?: 'Sector'; _id?: string | null; name?: string | null } | null> | null;
      occupation?: { __typename?: 'Occupation'; _id?: string | null; name?: string | null } | null;
      baseSalary?: { __typename?: 'SearchedProfileBaseSalary'; min?: number | null; max?: number | null } | null;
      createdBy?: {
        __typename?: 'User';
        _id: string;
        name?: string | null;
        title?: string | null;
        image?: string | null;
        isTop?: boolean | null;
      } | null;
      sites?: {
        __typename?: 'AreaSearch';
        areas?: Array<{ __typename?: 'Area'; name?: string | null; radius?: number | null } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type SelectCandidateQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
}>;

export type SelectCandidateQuery = {
  __typename?: 'Query';
  items?: {
    __typename?: 'CandidateList';
    pageInfo?: {
      __typename?: 'PageInfo';
      count?: any | null;
      page?: any | null;
      limit?: any | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
      endCursor?: string | null;
    } | null;
    items?: Array<{
      __typename?: 'Candidate';
      _id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      fullName?: string | null;
      resumeUrl?: string | null;
      url?: string | null;
      createdAt?: any | null;
    } | null> | null;
  } | null;
};

export type SelectMemberQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  filter?: InputMaybe<UsersFilterInput>;
}>;

export type SelectMemberQuery = {
  __typename?: 'Query';
  members?: {
    __typename?: 'UserList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null } | null;
    items?: Array<{ __typename?: 'User'; _id: string; name?: string | null; image?: string | null; title?: string | null } | null> | null;
  } | null;
};

export type OccupationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
}>;

export type OccupationsQuery = {
  __typename?: 'Query';
  items?: {
    __typename?: 'OccupationList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null; page?: any | null; limit?: any | null } | null;
    items?: Array<{ __typename?: 'Occupation'; _id?: string | null; name?: string | null } | null> | null;
  } | null;
};

export type SectorsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
}>;

export type SectorsQuery = {
  __typename?: 'Query';
  items?: {
    __typename?: 'SectorList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null; page?: any | null; limit?: any | null } | null;
    items?: Array<{ __typename?: 'Sector'; _id?: string | null; name?: string | null } | null> | null;
  } | null;
};

export type SelectToolQueryVariables = Exact<{
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
}>;

export type SelectToolQuery = {
  __typename?: 'Query';
  items?: {
    __typename?: 'ToolList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null; page?: any | null; limit?: any | null } | null;
    items?: Array<{ __typename?: 'Tool'; _id: string; name?: string | null } | null> | null;
  } | null;
};

export type UpdateToolMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateToolInput;
}>;

export type UpdateToolMutation = {
  __typename?: 'Mutation';
  updateTool?: {
    __typename?: 'updateToolOutput';
    item?: {
      __typename?: 'Tool';
      _id: string;
      name?: string | null;
      author?: string | null;
      authorUrl?: string | null;
      slug?: string | null;
      description?: string | null;
      type?: string | null;
      nbMaxParticipants?: number | null;
      duration?: number | null;
      featured?: boolean | null;
      productId?: string | null;
      price?: number | null;
      permissions?: string | null;
      priceId?: string | null;
      priceType?: string | null;
    } | null;
  } | null;
};

export type CreateToolMutationVariables = Exact<{
  input: CreateToolInput;
}>;

export type CreateToolMutation = {
  __typename?: 'Mutation';
  createTool?: {
    __typename?: 'createToolOutput';
    item?: {
      __typename?: 'Tool';
      _id: string;
      name?: string | null;
      author?: string | null;
      authorUrl?: string | null;
      slug?: string | null;
      description?: string | null;
      type?: string | null;
      nbMaxParticipants?: number | null;
      duration?: number | null;
      featured?: boolean | null;
      productId?: string | null;
      price?: number | null;
      permissions?: string | null;
      priceId?: string | null;
      priceType?: string | null;
    } | null;
  } | null;
};

export type UpdateAafInvoiceContactMutationVariables = Exact<{
  input: UpdateAafInvoiceContactInput;
}>;

export type UpdateAafInvoiceContactMutation = {
  __typename?: 'Mutation';
  updateAAFInvoiceContact?: {
    __typename?: 'updateAAFInvoiceContactOutput';
    item?: {
      __typename?: 'Contact';
      _id?: string | null;
      aafStartUrl?: string | null;
      aafConfirmUrl?: string | null;
      events?: Array<{
        __typename?: 'ContactEvent';
        _id?: string | null;
        name?: string | null;
        eventType?: string | null;
        createdAt?: any | null;
        metadata?: { __typename?: 'ContactEventMetadata'; message?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type AdminContactInvoiceListQueryVariables = Exact<{
  page: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  filter?: InputMaybe<ContactInvoicesFilterInput>;
}>;

export type AdminContactInvoiceListQuery = {
  __typename?: 'Query';
  contactInvoices?: {
    __typename?: 'ContactInvoicesList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null; page?: any | null; limit?: any | null } | null;
    items?: Array<{
      __typename?: 'ContactInvoice';
      name?: string | null;
      amount?: number | null;
      date?: any | null;
      type?: string | null;
      url?: string | null;
      contact?: { __typename?: 'Contact'; _id?: string | null; name?: string | null } | null;
      from?: { __typename?: 'User'; _id: string; name?: string | null; image?: string | null; title?: string | null } | null;
      to?: { __typename?: 'User'; _id: string; name?: string | null; image?: string | null; title?: string | null } | null;
    } | null> | null;
  } | null;
};

export type EventFieldsFragment = {
  __typename?: 'Event';
  _id: string;
  duration?: number | null;
  startAt?: any | null;
  endAt?: any | null;
  toolId: string;
  nbMaxParticipants?: number | null;
  name?: string | null;
  url?: string | null;
  author?: string | null;
  authorUrl?: string | null;
  description?: string | null;
  tool?: {
    __typename?: 'Tool';
    _id: string;
    type?: string | null;
    name?: string | null;
    author?: string | null;
    authorUrl?: string | null;
    description?: string | null;
    duration?: number | null;
  } | null;
  participants?: Array<{
    __typename?: 'EventParticipant';
    _id: string;
    status?: string | null;
    user?: { __typename?: 'User'; _id: string; name?: string | null; image?: string | null } | null;
  } | null> | null;
} & { ' $fragmentName'?: 'EventFieldsFragment' };

export type AdminEventCalendarQueryVariables = Exact<{ [key: string]: never }>;

export type AdminEventCalendarQuery = {
  __typename?: 'Query';
  events?: {
    __typename?: 'EventList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null; page?: any | null; limit?: any | null } | null;
    items?: Array<({ __typename?: 'Event' } & { ' $fragmentRefs'?: { EventFieldsFragment: EventFieldsFragment } }) | null> | null;
  } | null;
};

export type CreateEventMutationVariables = Exact<{
  input: CreateEventInput;
}>;

export type CreateEventMutation = {
  __typename?: 'Mutation';
  createEvent?: {
    __typename?: 'createEventOutput';
    item?: ({ __typename?: 'Event' } & { ' $fragmentRefs'?: { EventFieldsFragment: EventFieldsFragment } }) | null;
  } | null;
};

export type UpdateEventMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateEventInput;
}>;

export type UpdateEventMutation = {
  __typename?: 'Mutation';
  updateEvent?: {
    __typename?: 'updateEventOutput';
    item?: ({ __typename?: 'Event' } & { ' $fragmentRefs'?: { EventFieldsFragment: EventFieldsFragment } }) | null;
  } | null;
};

export type DeleteEventMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;

export type DeleteEventMutation = {
  __typename?: 'Mutation';
  deleteEvent?: {
    __typename?: 'updateEventOutput';
    item?: ({ __typename?: 'Event' } & { ' $fragmentRefs'?: { EventFieldsFragment: EventFieldsFragment } }) | null;
  } | null;
};

export type AdminToolListQueryVariables = Exact<{
  page: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  filter?: InputMaybe<ToolsFilterInput>;
}>;

export type AdminToolListQuery = {
  __typename?: 'Query';
  tools?: {
    __typename?: 'ToolList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null; page?: any | null; limit?: any | null } | null;
    items?: Array<{
      __typename?: 'Tool';
      _id: string;
      name?: string | null;
      author?: string | null;
      authorUrl?: string | null;
      slug?: string | null;
      description?: string | null;
      type?: string | null;
      duration?: number | null;
      nbMaxParticipants?: number | null;
      featured?: boolean | null;
      productId?: string | null;
      permissions?: string | null;
      price?: number | null;
      priceId?: string | null;
      priceType?: string | null;
    } | null> | null;
  } | null;
};

export type DeleteToolMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;

export type DeleteToolMutation = {
  __typename?: 'Mutation';
  deleteTool?: {
    __typename?: 'updateToolOutput';
    item?: {
      __typename?: 'Tool';
      _id: string;
      name?: string | null;
      author?: string | null;
      authorUrl?: string | null;
      slug?: string | null;
      description?: string | null;
      type?: string | null;
      duration?: number | null;
      nbMaxParticipants?: number | null;
      featured?: boolean | null;
      productId?: string | null;
      permissions?: string | null;
      price?: number | null;
      priceId?: string | null;
      priceType?: string | null;
    } | null;
  } | null;
};

export type ContactFragmentFragment = {
  __typename?: 'Contact';
  _id?: string | null;
  status?: string | null;
  name?: string | null;
  bountyStart?: number | null;
  bountyConfirm?: number | null;
  candidateAcceptedAt?: any | null;
  candidateRefusedAt?: any | null;
  rulesAcceptedAt?: any | null;
  rulesRefusedAt?: any | null;
  rulesRefusedFor?: string | null;
  candidateRefusedFor?: string | null;
  candidateInProcessAt?: any | null;
  candidateNotInProcessAt?: any | null;
  candidateUnderOfferAt?: any | null;
  candidateNotUnderOfferAt?: any | null;
  candidateOfferAcceptedAt?: any | null;
  candidateOfferRefusedAt?: any | null;
  candidateTrainingStartedAt?: any | null;
  candidateTrainingNotStartedAt?: any | null;
  candidateTrainingConfirmedAt?: any | null;
  candidateTrainingNotConfirmedAt?: any | null;
  candidateTrainingStartPotentialDate?: any | null;
  candidateTrainingConfirmedPotentialDate?: any | null;
  processSucceededAt?: any | null;
  shouldAnswerBefore?: any | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  searchedProfile?: {
    __typename?: 'SearchedProfile';
    _id: string;
    name?: string | null;
    bountyStart?: number | null;
    bountyConfirm?: number | null;
    bountyDescription?: string | null;
    description?: string | null;
    sourcingAt?: any | null;
    sourcingBy?: string | null;
    exclusiveSourcer?: { __typename?: 'User'; _id: string; name?: string | null; image?: string | null; title?: string | null } | null;
  } | null;
  availableProfile?: {
    __typename?: 'AvailableProfile';
    _id: string;
    name?: string | null;
    bounty?: number | null;
    bountyDescription?: string | null;
    description?: string | null;
  } | null;
  candidate?: { __typename?: 'Candidate'; _id?: string | null; fullName?: string | null; url?: string | null } | null;
  createdBy?: { __typename?: 'User'; _id: string; name?: string | null; title?: string | null; image?: string | null; isTop?: boolean | null } | null;
  searcher?: { __typename?: 'User'; _id: string; name?: string | null; title?: string | null; image?: string | null; isTop?: boolean | null } | null;
  events?: Array<{
    __typename?: 'ContactEvent';
    name?: string | null;
    eventType?: string | null;
    messageId?: string | null;
    createdAt?: any | null;
    parentId?: string | null;
    metadata?: { __typename?: 'ContactEventMetadata'; message?: string | null } | null;
  } | null> | null;
} & { ' $fragmentName'?: 'ContactFragmentFragment' };

export type UseContactQueryVariables = Exact<{
  page: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  filter?: InputMaybe<ContactsFilterInput>;
}>;

export type UseContactQuery = {
  __typename?: 'Query';
  contacts?: {
    __typename?: 'ContactList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null; page?: any | null; limit?: any | null } | null;
    items?: Array<({ __typename?: 'Contact' } & { ' $fragmentRefs'?: { ContactFragmentFragment: ContactFragmentFragment } }) | null> | null;
  } | null;
};

export type UpdateContactStatusMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateContactStatusInput;
}>;

export type UpdateContactStatusMutation = {
  __typename?: 'Mutation';
  updateContactStatus?: {
    __typename?: 'updateContactStatusOutput';
    item?: ({ __typename?: 'Contact' } & { ' $fragmentRefs'?: { ContactFragmentFragment: ContactFragmentFragment } }) | null;
  } | null;
};

export type ImpersonateUserMutationVariables = Exact<{
  input: ImpersonateUserInput;
}>;

export type ImpersonateUserMutation = {
  __typename?: 'Mutation';
  impersonateUser?: {
    __typename?: 'UserDetailOutput';
    item?: { __typename?: 'User'; _id: string; roles?: Array<string | null> | null } | null;
  } | null;
};

export type ParticipateEventMutationVariables = Exact<{
  input: CreateEventParticipantInput;
}>;

export type ParticipateEventMutation = {
  __typename?: 'Mutation';
  createEventParticipant?: {
    __typename?: 'createEventParticipantOutput';
    item?: {
      __typename?: 'createEventParticipantOutputItem';
      paymentLink?: string | null;
      eventParticipant?: { __typename?: 'EventParticipant'; _id: string; userId: string; createdAt?: any | null } | null;
    } | null;
  } | null;
};

export type UpdateParticipationMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateEventParticipantInput;
}>;

export type UpdateParticipationMutation = {
  __typename?: 'Mutation';
  updateEventParticipant?: { __typename?: 'updateEventParticipantOutput'; item?: { __typename?: 'EventParticipant'; _id: string } | null } | null;
};

export type UpdateInvoiceMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateInvoiceInput;
}>;

export type UpdateInvoiceMutation = {
  __typename?: 'Mutation';
  updateInvoice?: {
    __typename?: 'updateInvoiceOutput';
    item?: {
      __typename?: 'Invoice';
      _id: string;
      code: string;
      date: any;
      metadata?: any | null;
      from: { __typename?: 'InvoiceAddress'; name?: string | null; address?: string | null };
      to?: { __typename?: 'InvoiceAddress'; name?: string | null; address?: string | null } | null;
      lines: Array<{ __typename?: 'InvoiceLine'; name: string; description?: string | null; amount: number; total: number }>;
      contact?: { __typename?: 'Contact'; _id?: string | null; name?: string | null } | null;
    } | null;
  } | null;
};

export type CreateInvoiceMutationVariables = Exact<{
  input: CreateInvoiceInput;
}>;

export type CreateInvoiceMutation = {
  __typename?: 'Mutation';
  createInvoice?: {
    __typename?: 'createInvoiceOutput';
    item?: {
      __typename?: 'Invoice';
      _id: string;
      code: string;
      date: any;
      metadata?: any | null;
      from: { __typename?: 'InvoiceAddress'; name?: string | null; address?: string | null };
      to?: { __typename?: 'InvoiceAddress'; name?: string | null; address?: string | null } | null;
      lines: Array<{ __typename?: 'InvoiceLine'; name: string; description?: string | null; amount: number; total: number }>;
      contact?: { __typename?: 'Contact'; _id?: string | null; name?: string | null } | null;
    } | null;
  } | null;
};

export type InvoiceListQueryVariables = Exact<{
  page: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  filter?: InputMaybe<InvoicesFilterInput>;
}>;

export type InvoiceListQuery = {
  __typename?: 'Query';
  myInvoices?: {
    __typename?: 'InvoiceList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null; page?: any | null; limit?: any | null } | null;
    items?: Array<{
      __typename?: 'Invoice';
      _id: string;
      code: string;
      date: any;
      metadata?: any | null;
      from: { __typename?: 'InvoiceAddress'; name?: string | null; address?: string | null };
      to?: { __typename?: 'InvoiceAddress'; name?: string | null; address?: string | null } | null;
      lines: Array<{ __typename?: 'InvoiceLine'; name: string; description?: string | null; amount: number; total: number }>;
      contact?: { __typename?: 'Contact'; _id?: string | null; name?: string | null } | null;
    } | null> | null;
  } | null;
};

export type UpdateMyInvoiceMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateMyInvoiceInput;
}>;

export type UpdateMyInvoiceMutation = {
  __typename?: 'Mutation';
  updateMyInvoice?: {
    __typename?: 'updateInvoiceOutput';
    item?: {
      __typename?: 'Invoice';
      _id: string;
      to?: { __typename?: 'InvoiceAddress'; name?: string | null; address?: string | null } | null;
    } | null;
  } | null;
};

export type AdminInvoiceListQueryVariables = Exact<{
  page: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  filter?: InputMaybe<InvoicesFilterInput>;
}>;

export type AdminInvoiceListQuery = {
  __typename?: 'Query';
  invoices?: {
    __typename?: 'InvoiceList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null; page?: any | null; limit?: any | null } | null;
    items?: Array<{
      __typename?: 'Invoice';
      _id: string;
      code: string;
      date: any;
      metadata?: any | null;
      from: { __typename?: 'InvoiceAddress'; name?: string | null; address?: string | null };
      to?: { __typename?: 'InvoiceAddress'; name?: string | null; address?: string | null } | null;
      lines: Array<{ __typename?: 'InvoiceLine'; name: string; description?: string | null; amount: number; total: number }>;
      user?: { __typename?: 'User'; _id: string; name?: string | null; image?: string | null; title?: string | null } | null;
      contact?: { __typename?: 'Contact'; _id?: string | null; name?: string | null } | null;
    } | null> | null;
  } | null;
};

export type DuplicateInvoiceMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DuplicateInvoiceMutation = {
  __typename?: 'Mutation';
  duplicateInvoice?: {
    __typename?: 'duplicateInvoiceOutput';
    items?: Array<{
      __typename?: 'Invoice';
      _id: string;
      code: string;
      date: any;
      metadata?: any | null;
      from: { __typename?: 'InvoiceAddress'; name?: string | null; address?: string | null };
      to?: { __typename?: 'InvoiceAddress'; name?: string | null; address?: string | null } | null;
      lines: Array<{ __typename?: 'InvoiceLine'; name: string; description?: string | null; amount: number; total: number }>;
      user?: { __typename?: 'User'; _id: string; name?: string | null; image?: string | null; title?: string | null } | null;
      contact?: { __typename?: 'Contact'; _id?: string | null; name?: string | null } | null;
    } | null> | null;
  } | null;
};

export type DeleteInvoiceMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;

export type DeleteInvoiceMutation = {
  __typename?: 'Mutation';
  deleteInvoice?: {
    __typename?: 'updateInvoiceOutput';
    item?: {
      __typename?: 'Invoice';
      _id: string;
      code: string;
      date: any;
      metadata?: any | null;
      from: { __typename?: 'InvoiceAddress'; name?: string | null; address?: string | null };
      to?: { __typename?: 'InvoiceAddress'; name?: string | null; address?: string | null } | null;
      lines: Array<{ __typename?: 'InvoiceLine'; name: string; description?: string | null; amount: number; total: number }>;
      user?: { __typename?: 'User'; _id: string; name?: string | null; image?: string | null; title?: string | null } | null;
      contact?: { __typename?: 'Contact'; _id?: string | null; name?: string | null } | null;
    } | null;
  } | null;
};

export type MySubscriptionQueryVariables = Exact<{ [key: string]: never }>;

export type MySubscriptionQuery = {
  __typename?: 'Query';
  mySubscription?: {
    __typename?: 'mySubscriptionOutput';
    item?: {
      __typename?: 'Subscription';
      plans?: Array<{ __typename?: 'Plan'; id?: string | null; status?: string | null; validUntil?: any | null } | null> | null;
    } | null;
  } | null;
};

export type CreateSubscriptionMutationVariables = Exact<{
  input: CreateSubscriptionInput;
}>;

export type CreateSubscriptionMutation = {
  __typename?: 'Mutation';
  createSubscription?: {
    __typename?: 'createSubscriptionOutput';
    item?: { __typename?: 'StripeSubscription'; id?: string | null; url?: string | null } | null;
  } | null;
};

export type DeleteSubscriptionMutationVariables = Exact<{
  input: DeleteSubscriptionInput;
}>;

export type DeleteSubscriptionMutation = {
  __typename?: 'Mutation';
  deleteSubscription?: { __typename?: 'deleteSubscriptionOutput'; status?: string | null } | null;
};

export type GetBillingPortalMutationVariables = Exact<{
  input: GetBillingPortalInput;
}>;

export type GetBillingPortalMutation = {
  __typename?: 'Mutation';
  getBillingPortal?: { __typename?: 'getBillingPortalOutput'; url?: string | null } | null;
};

export type CreateProspectMutationVariables = Exact<{
  input: CreateProspectInput;
}>;

export type CreateProspectMutation = {
  __typename?: 'Mutation';
  createProspect?: {
    __typename?: 'createProspectOutput';
    item?: { __typename?: 'Prospect'; _id: string; mission?: string | null; candidate?: string | null } | null;
  } | null;
};

export type UpdateProspectMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateProspectInput;
}>;

export type UpdateProspectMutation = {
  __typename?: 'Mutation';
  updateProspect?: {
    __typename?: 'updateProspectOutput';
    item?: { __typename?: 'Prospect'; _id: string; mission?: string | null; candidate?: string | null; email?: string | null } | null;
  } | null;
};

export type SelectUserQueryVariables = Exact<{ [key: string]: never }>;

export type SelectUserQuery = {
  __typename?: 'Query';
  users?: {
    __typename?: 'UserList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null } | null;
    items?: Array<{ __typename?: 'User'; _id: string; name?: string | null; image?: string | null; title?: string | null } | null> | null;
  } | null;
};

export type SelectUsersQueryVariables = Exact<{ [key: string]: never }>;

export type SelectUsersQuery = {
  __typename?: 'Query';
  users?: {
    __typename?: 'UserList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null } | null;
    items?: Array<{ __typename?: 'User'; _id: string; name?: string | null; image?: string | null; title?: string | null } | null> | null;
  } | null;
};

export type ChatUserFragmentFragment = {
  __typename?: 'User';
  _id: string;
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  title?: string | null;
  image?: string | null;
  isTop?: boolean | null;
  ambassadorFor?: string | null;
  openToSource?: boolean | null;
} & { ' $fragmentName'?: 'ChatUserFragmentFragment' };

export type DiscussionFragmentFragment = {
  __typename?: 'Discussion';
  _id?: string | null;
  type?: DiscussionType | null;
  name?: string | null;
  unreadCount?: any | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  participants?: Array<{ __typename?: 'User' } & { ' $fragmentRefs'?: { ChatUserFragmentFragment: ChatUserFragmentFragment } }> | null;
  lastMessage?: {
    __typename?: 'LastMessage';
    content?: string | null;
    senderId?: string | null;
    createdAt?: any | null;
    sender?: ({ __typename?: 'User' } & { ' $fragmentRefs'?: { ChatUserFragmentFragment: ChatUserFragmentFragment } }) | null;
  } | null;
  createdBy?: ({ __typename?: 'User' } & { ' $fragmentRefs'?: { ChatUserFragmentFragment: ChatUserFragmentFragment } }) | null;
} & { ' $fragmentName'?: 'DiscussionFragmentFragment' };

export type UseChatQueryVariables = Exact<{
  page: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  filter?: InputMaybe<DiscussionsFilterInput>;
}>;

export type UseChatQuery = {
  __typename?: 'Query';
  myDiscussions: {
    __typename?: 'DiscussionsResponse';
    pageInfo: { __typename?: 'PageInfo'; count?: any | null; page?: any | null; limit?: any | null };
    items: Array<{ __typename?: 'Discussion' } & { ' $fragmentRefs'?: { DiscussionFragmentFragment: DiscussionFragmentFragment } }>;
  };
};

export type GetDiscussionQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;

export type GetDiscussionQuery = {
  __typename?: 'Query';
  discussionAndConnection?: {
    __typename?: 'DiscussionAndConnectionResponse';
    success: boolean;
    code?: string | null;
    error?: string | null;
    item?: {
      __typename?: 'DiscussionAndConnection';
      discussion?: ({ __typename?: 'Discussion' } & { ' $fragmentRefs'?: { DiscussionFragmentFragment: DiscussionFragmentFragment } }) | null;
      connection?: { __typename?: 'DiscussionConnection'; token?: string | null; url?: string | null } | null;
    } | null;
  } | null;
};

export type CreateDiscussionMutationVariables = Exact<{
  input: CreateDiscussionInput;
}>;

export type CreateDiscussionMutation = {
  __typename?: 'Mutation';
  createDiscussion: {
    __typename?: 'DiscussionResponse';
    success: boolean;
    code?: string | null;
    error?: string | null;
    item?: ({ __typename?: 'Discussion' } & { ' $fragmentRefs'?: { DiscussionFragmentFragment: DiscussionFragmentFragment } }) | null;
  };
};

export type MessageFragmentFragment = {
  __typename?: 'Message';
  _id: string;
  discussionId: string;
  senderId: string;
  editedAt?: any | null;
  deletedAt?: any | null;
  content: string;
  type: MessageType;
  readByIds?: Array<string> | null;
  createdAt: any;
  updatedAt: any;
  sender: { __typename?: 'User' } & { ' $fragmentRefs'?: { ChatUserFragmentFragment: ChatUserFragmentFragment } };
  metadata?: {
    __typename?: 'MessageMetadata';
    fileName?: string | null;
    fileSize?: number | null;
    fileUrl?: string | null;
    imageUrl?: string | null;
    imageWidth?: number | null;
    imageHeight?: number | null;
  } | null;
} & { ' $fragmentName'?: 'MessageFragmentFragment' };

export type ListMessagesQueryVariables = Exact<{
  page: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  filter?: InputMaybe<MessagesFilterInput>;
}>;

export type ListMessagesQuery = {
  __typename?: 'Query';
  messages: {
    __typename?: 'MessagesResponse';
    pageInfo: { __typename?: 'PageInfo'; count?: any | null; page?: any | null; limit?: any | null };
    items: Array<{ __typename?: 'Message' } & { ' $fragmentRefs'?: { MessageFragmentFragment: MessageFragmentFragment } }>;
  };
};

export type CreateMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;

export type CreateMessageMutation = {
  __typename?: 'Mutation';
  createMessage: {
    __typename?: 'MessageResponse';
    success: boolean;
    code?: string | null;
    error?: string | null;
    item?: ({ __typename?: 'Message' } & { ' $fragmentRefs'?: { MessageFragmentFragment: MessageFragmentFragment } }) | null;
  };
};

export type MarkMessageAsReadMutationVariables = Exact<{
  input: MarkMessageAsReadInput;
}>;

export type MarkMessageAsReadMutation = {
  __typename?: 'Mutation';
  markMessageAsRead: { __typename?: 'MarkAsReadResponse'; success: boolean; code?: string | null; error?: string | null };
};

export type GetUnreadCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetUnreadCountQuery = {
  __typename?: 'Query';
  unreadCount: {
    __typename?: 'UnreadCountResponse';
    totalUnread: number;
    discussions: Array<{ __typename?: 'Discussion' } & { ' $fragmentRefs'?: { DiscussionFragmentFragment: DiscussionFragmentFragment } }>;
  };
};

export type NotificationSearchedProfileFragmentFragment = {
  __typename?: 'SearchedProfile';
  _id: string;
  name?: string | null;
  bounty?: number | null;
  createdBy?: { __typename?: 'User'; _id: string; name?: string | null; title?: string | null; image?: string | null; isTop?: boolean | null } | null;
} & { ' $fragmentName'?: 'NotificationSearchedProfileFragmentFragment' };

export type NotificationAvailableProfileFragmentFragment = {
  __typename?: 'AvailableProfile';
  _id: string;
  name?: string | null;
  bounty?: number | null;
  createdBy?: { __typename?: 'User'; _id: string; name?: string | null; title?: string | null; image?: string | null; isTop?: boolean | null } | null;
} & { ' $fragmentName'?: 'NotificationAvailableProfileFragmentFragment' };

export type NotificationFragmentFragment = {
  __typename?: 'Notification';
  _id?: string | null;
  kind?: NotificationKind | null;
  type?: string | null;
  objectId?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  viewedAt?: any | null;
  searchedProfile?:
    | ({ __typename?: 'SearchedProfile' } & {
        ' $fragmentRefs'?: { NotificationSearchedProfileFragmentFragment: NotificationSearchedProfileFragmentFragment };
      })
    | null;
  availableProfile?:
    | ({ __typename?: 'AvailableProfile' } & {
        ' $fragmentRefs'?: { NotificationAvailableProfileFragmentFragment: NotificationAvailableProfileFragmentFragment };
      })
    | null;
} & { ' $fragmentName'?: 'NotificationFragmentFragment' };

export type NotificationsQueryVariables = Exact<{
  page: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  filter?: InputMaybe<NotificationsFilterInput>;
}>;

export type NotificationsQuery = {
  __typename?: 'Query';
  myNotifications: {
    __typename?: 'NotificationList';
    items?: Array<
      ({ __typename?: 'Notification' } & { ' $fragmentRefs'?: { NotificationFragmentFragment: NotificationFragmentFragment } }) | null
    > | null;
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null; page?: any | null; limit?: any | null } | null;
  };
};

export type UpdateNotificationMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateNotificationInput;
}>;

export type UpdateNotificationMutation = {
  __typename?: 'Mutation';
  updateNotification: {
    __typename?: 'updateNotificationOutput';
    success?: boolean | null;
    code?: string | null;
    error?: string | null;
    item?: ({ __typename?: 'Notification' } & { ' $fragmentRefs'?: { NotificationFragmentFragment: NotificationFragmentFragment } }) | null;
  };
};

export type CompanyUserFieldsFragment = {
  __typename?: 'User';
  _id: string;
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  image?: string | null;
  email?: string | null;
  title?: string | null;
  url?: string | null;
  bio?: string | null;
  phone?: string | null;
  businessName?: string | null;
  sectorIds?: Array<string | null> | null;
  roles?: Array<string | null> | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  lastLoginAt?: any | null;
  sectors?: Array<{ __typename?: 'Sector'; _id?: string | null; name?: string | null } | null> | null;
  locations?: {
    __typename?: 'AreaSearch';
    areas?: Array<{
      __typename?: 'Area';
      name?: string | null;
      geo?: { __typename?: 'Geo'; coordinates?: Array<number | null> | null; type?: string | null } | null;
    } | null> | null;
  } | null;
} & { ' $fragmentName'?: 'CompanyUserFieldsFragment' };

export type AdminCompaniesQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  filter?: InputMaybe<UsersFilterInput>;
}>;

export type AdminCompaniesQuery = {
  __typename?: 'Query';
  users?: {
    __typename?: 'UserList';
    pageInfo?: {
      __typename?: 'PageInfo';
      count?: any | null;
      page?: any | null;
      limit?: any | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
      endCursor?: string | null;
    } | null;
    items?: Array<({ __typename?: 'User' } & { ' $fragmentRefs'?: { CompanyUserFieldsFragment: CompanyUserFieldsFragment } }) | null> | null;
  } | null;
};

export type UpdateCompanyUserMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateUserInput;
}>;

export type UpdateCompanyUserMutation = {
  __typename?: 'Mutation';
  updateUser?: {
    __typename?: 'updateUserOutput';
    item?: ({ __typename?: 'User' } & { ' $fragmentRefs'?: { CompanyUserFieldsFragment: CompanyUserFieldsFragment } }) | null;
  } | null;
};

export type ProspectsQueryVariables = Exact<{ [key: string]: never }>;

export type ProspectsQuery = {
  __typename?: 'Query';
  prospects?: {
    __typename?: 'ProspectList';
    pageInfo?: {
      __typename?: 'PageInfo';
      count?: any | null;
      page?: any | null;
      limit?: any | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
      endCursor?: string | null;
    } | null;
    items?: Array<{
      __typename?: 'Prospect';
      _id: string;
      mission?: string | null;
      candidate?: string | null;
      email?: string | null;
      createdAt?: any | null;
      updatedAt?: any | null;
    } | null> | null;
  } | null;
};

export type UserFieldsFragment = {
  __typename?: 'User';
  _id: string;
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  image?: string | null;
  email?: string | null;
  title?: string | null;
  url?: string | null;
  bio?: string | null;
  phone?: string | null;
  companyLocation?: string | null;
  sector?: string | null;
  sectorIds?: Array<string | null> | null;
  occupationIds?: Array<string | null> | null;
  occupation?: string | null;
  countryIds?: Array<string | null> | null;
  companyArea?: string | null;
  behaviorGuidelines?: string | null;
  roles?: Array<string | null> | null;
  companyClients?: string | null;
  companySize?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  ambassadorFor?: string | null;
  onHolidaysUntil?: any | null;
  onHolidays?: boolean | null;
  experience?: string | null;
  strategy?: string | null;
  motivation?: Array<string | null> | null;
  motivation_other?: string | null;
  referrer?: string | null;
  referrer_other?: string | null;
  businessRegistrationId?: string | null;
  isTop?: boolean | null;
  zone?: string | null;
  lastLoginAt?: any | null;
  level?: number | null;
  certificationIds?: Array<string | null> | null;
  recruiterToolIds?: Array<string | null> | null;
  hasPendingActions?: boolean | null;
  sectors?: Array<{ __typename?: 'Sector'; _id?: string | null; name?: string | null } | null> | null;
  occupations?: Array<{ __typename?: 'Occupation'; _id?: string | null; name?: string | null } | null> | null;
  companySalaryTreated?: { __typename?: 'CompanySalaryTreated'; min?: number | null; max?: number | null } | null;
  areaSearch?: {
    __typename?: 'AreaSearch';
    areas?: Array<{
      __typename?: 'Area';
      name?: string | null;
      radius?: number | null;
      geo?: { __typename?: 'Geo'; coordinates?: Array<number | null> | null; type?: string | null } | null;
    } | null> | null;
  } | null;
  notifications?: {
    __typename?: 'UserNotification';
    skipNewMissions?: boolean | null;
    skipNewCandidates?: boolean | null;
    skipDailyEmail?: boolean | null;
  } | null;
  affiliate?: {
    __typename?: 'Affiliate';
    _id: string;
    affiliateId?: string | null;
    parentUser?: { __typename?: 'User'; _id: string; name?: string | null } | null;
  } | null;
  flags?: {
    __typename?: 'UserFlags';
    seenSectorsAt?: any | null;
    seenOccupationsAt?: any | null;
    seenAreasAt?: any | null;
    seenBrowserNotificationsAt?: any | null;
    sentToMakeAt?: any | null;
  } | null;
  locations?: {
    __typename?: 'AreaSearch';
    areas?: Array<{
      __typename?: 'Area';
      name?: string | null;
      geo?: { __typename?: 'Geo'; coordinates?: Array<number | null> | null; type?: string | null } | null;
    } | null> | null;
  } | null;
  recruiterTools?: Array<{
    __typename?: 'RecruiterTool';
    _id: string;
    name?: string | null;
    url?: string | null;
    category?: string | null;
    description?: string | null;
    faviconUrl?: string | null;
  } | null> | null;
} & { ' $fragmentName'?: 'UserFieldsFragment' };

export type AdminUsersQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  filter?: InputMaybe<UsersFilterInput>;
}>;

export type AdminUsersQuery = {
  __typename?: 'Query';
  users?: {
    __typename?: 'UserList';
    pageInfo?: {
      __typename?: 'PageInfo';
      count?: any | null;
      page?: any | null;
      limit?: any | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
      endCursor?: string | null;
    } | null;
    items?: Array<({ __typename?: 'User' } & { ' $fragmentRefs'?: { UserFieldsFragment: UserFieldsFragment } }) | null> | null;
  } | null;
};

export type UpdateUserMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateUserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser?: {
    __typename?: 'updateUserOutput';
    item?: ({ __typename?: 'User' } & { ' $fragmentRefs'?: { UserFieldsFragment: UserFieldsFragment } }) | null;
  } | null;
};

export type GrantRoleMutationVariables = Exact<{
  input: GrantRoleInput;
}>;

export type GrantRoleMutation = {
  __typename?: 'Mutation';
  grantRole?: { __typename?: 'UserDetailOutput'; item?: { __typename?: 'User'; _id: string; roles?: Array<string | null> | null } | null } | null;
};

export type RemoveRoleMutationVariables = Exact<{
  input: RemoveRoleInput;
}>;

export type RemoveRoleMutation = {
  __typename?: 'Mutation';
  removeRole?: { __typename?: 'UserDetailOutput'; item?: { __typename?: 'User'; _id: string; roles?: Array<string | null> | null } | null } | null;
};

export type ArchiveUserMutationVariables = Exact<{
  input: ArchiveUserInput;
}>;

export type ArchiveUserMutation = {
  __typename?: 'Mutation';
  archiveUser?: { __typename?: 'UserDetailOutput'; item?: { __typename?: 'User'; _id: string; roles?: Array<string | null> | null } | null } | null;
};

export type UnarchiveUserMutationVariables = Exact<{
  input: ArchiveUserInput;
}>;

export type UnarchiveUserMutation = {
  __typename?: 'Mutation';
  unarchiveUser?: { __typename?: 'UserDetailOutput'; item?: { __typename?: 'User'; _id: string; roles?: Array<string | null> | null } | null } | null;
};

export type SetParentAffiliateMutationVariables = Exact<{
  input: SetParentAffiliateInput;
}>;

export type SetParentAffiliateMutation = {
  __typename?: 'Mutation';
  setParentAffiliate?: { __typename?: 'setParentAffiliateOutput'; status?: number | null } | null;
};

export type CreateContactMissionAvailableProfileMutationVariables = Exact<{
  input: CreateContactMissionInput;
}>;

export type CreateContactMissionAvailableProfileMutation = {
  __typename?: 'Mutation';
  createContactMission?: { __typename?: 'createContactMissionOutput'; item?: { __typename?: 'ContactMission'; _id?: string | null } | null } | null;
};

export type AvailableProfilesQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AvailableProfilesFilterInput>;
}>;

export type AvailableProfilesQuery = {
  __typename?: 'Query';
  availableProfiles?: {
    __typename?: 'AvailableProfileList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null; page?: any | null; limit?: any | null } | null;
    items?: Array<{
      __typename?: 'AvailableProfile';
      _id: string;
      name?: string | null;
      bounty?: number | null;
      previousBounty?: number | null;
      bountyChangedAt?: any | null;
      sector?: string | null;
      sectorIds?: Array<string | null> | null;
      occupation?: string | null;
      occupationIds?: Array<string | null> | null;
      job?: string | null;
      client?: string | null;
      location?: string | null;
      experience?: string | null;
      description?: string | null;
      context?: string | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      expiresAt?: any | null;
      countryIds?: Array<string | null> | null;
      currency?: string | null;
      baseSalary?: { __typename?: 'AvailableProfileBaseSalary'; min?: number | null; max?: number | null } | null;
      createdBy?: {
        __typename?: 'User';
        _id: string;
        name?: string | null;
        title?: string | null;
        image?: string | null;
        isTop?: boolean | null;
        roles?: Array<string | null> | null;
        ambassadorFor?: string | null;
        rating?: {
          __typename?: 'UserRating';
          average?: number | null;
          count?: number | null;
          responsiveness?: number | null;
          relevance?: number | null;
          reliability?: number | null;
        } | null;
      } | null;
      contacts?: Array<{
        __typename?: 'Contact';
        status?: string | null;
        inProcess?: boolean | null;
        endedProcess?: boolean | null;
        processSucceeded?: boolean | null;
        processConfirmed?: boolean | null;
        contactStopped?: boolean | null;
        candidateUnderOfferAt?: any | null;
        contactInitiated?: boolean | null;
      } | null> | null;
      myMatchings?: Array<{
        __typename?: 'Matching';
        _id: string;
        viewedAt?: any | null;
        searchedProfileUserId: string;
        searchedProfileId: string;
        searchedProfile?: {
          __typename?: 'SearchedProfile';
          _id: string;
          name?: string | null;
          bounty?: number | null;
          previousBounty?: number | null;
          bountyChangedAt?: any | null;
          currency?: string | null;
          experience?: string | null;
          publishedAt?: any | null;
          sectorIds?: Array<string | null> | null;
          countryIds?: Array<string | null> | null;
          occupationId?: string | null;
          baseSalary?: { __typename?: 'SearchedProfileBaseSalary'; min?: number | null; max?: number | null } | null;
        } | null;
      } | null> | null;
      areaSearch?: {
        __typename?: 'AreaSearch';
        areas?: Array<{ __typename?: 'Area'; name?: string | null; radius?: number | null } | null> | null;
      } | null;
      sectors?: Array<{ __typename?: 'Sector'; name?: string | null } | null> | null;
    } | null> | null;
  } | null;
};

export type CreateCandidateMutationVariables = Exact<{
  input: CreateCandidateInput;
}>;

export type CreateCandidateMutation = {
  __typename?: 'Mutation';
  createCandidate?: {
    __typename?: 'createCandidateOutput';
    item?: {
      __typename?: 'Candidate';
      _id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      fullName?: string | null;
      resumeUrl?: string | null;
      url?: string | null;
      createdAt?: any | null;
    } | null;
  } | null;
};

export type DeleteCandidateMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;

export type DeleteCandidateMutation = {
  __typename?: 'Mutation';
  deleteCandidate?: { __typename?: 'deleteCandidateOutput'; item?: { __typename?: 'SearchedProfile'; _id: string } | null } | null;
};

export type UpdateCandidateMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateCandidateInput;
}>;

export type UpdateCandidateMutation = {
  __typename?: 'Mutation';
  updateCandidate?: {
    __typename?: 'updateCandidateOutput';
    item?: {
      __typename?: 'Candidate';
      _id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      fullName?: string | null;
      resumeUrl?: string | null;
      url?: string | null;
      createdAt?: any | null;
    } | null;
  } | null;
};

export type CandidatesQueryVariables = Exact<{ [key: string]: never }>;

export type CandidatesQuery = {
  __typename?: 'Query';
  candidates?: {
    __typename?: 'CandidateList';
    pageInfo?: {
      __typename?: 'PageInfo';
      count?: any | null;
      page?: any | null;
      limit?: any | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
      endCursor?: string | null;
    } | null;
    items?: Array<{
      __typename?: 'Candidate';
      _id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      fullName?: string | null;
      resumeUrl?: string | null;
      url?: string | null;
      createdAt?: any | null;
      availableProfiles?: Array<{
        __typename?: 'AvailableProfile';
        _id: string;
        name?: string | null;
        publishedAt?: any | null;
        expiresAt?: any | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type CreateContactDetailMutationVariables = Exact<{
  input: CreateContactInput;
}>;

export type CreateContactDetailMutation = {
  __typename?: 'Mutation';
  createContact?: { __typename?: 'createContactOutput'; item?: { __typename?: 'Contact'; _id?: string | null } | null } | null;
};

export type UpdateContactMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateContactInput;
}>;

export type UpdateContactMutation = {
  __typename?: 'Mutation';
  updateContact?: {
    __typename?: 'updateContactOutput';
    item?: {
      __typename?: 'Contact';
      _id?: string | null;
      shouldAnswerBefore?: any | null;
      candidateTrainingStartPotentialDate?: any | null;
      candidateTrainingConfirmedPotentialDate?: any | null;
    } | null;
  } | null;
};

export type CreateContactMissionDetailMutationVariables = Exact<{
  input: CreateContactMissionInput;
}>;

export type CreateContactMissionDetailMutation = {
  __typename?: 'Mutation';
  createContactMission?: { __typename?: 'createContactMissionOutput'; item?: { __typename?: 'ContactMission'; _id?: string | null } | null } | null;
};

export type ContactsDirectionQueryVariables = Exact<{
  filter?: InputMaybe<ContactsFilterInput>;
}>;

export type ContactsDirectionQuery = {
  __typename?: 'Query';
  candidateContacts?: {
    __typename?: 'ContactCandidateList';
    items?: Array<{
      __typename?: 'ContactCandidate';
      _id?: string | null;
      status?: string | null;
      bountyStart?: number | null;
      bountyConfirm?: number | null;
      candidateAcceptedAt?: any | null;
      candidateRefusedAt?: any | null;
      rulesAcceptedAt?: any | null;
      rulesRefusedAt?: any | null;
      candidateInProcessAt?: any | null;
      candidateNotInProcessAt?: any | null;
      candidateUnderOfferAt?: any | null;
      candidateNotUnderOfferAt?: any | null;
      candidateOfferAcceptedAt?: any | null;
      candidateOfferRefusedAt?: any | null;
      candidateTrainingStartedAt?: any | null;
      candidateTrainingNotStartedAt?: any | null;
      candidateTrainingConfirmedAt?: any | null;
      candidateTrainingNotConfirmedAt?: any | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      currency?: string | null;
      candidate?: { __typename?: 'Candidate'; _id?: string | null; fullName?: string | null } | null;
      searchedProfile?: {
        __typename?: 'SearchedProfile';
        _id: string;
        name?: string | null;
        bountyStart?: number | null;
        bountyConfirm?: number | null;
        publishedAt?: any | null;
        createdBy?: {
          __typename?: 'User';
          _id: string;
          firstName?: string | null;
          lastName?: string | null;
          name?: string | null;
          title?: string | null;
          image?: string | null;
          isTop?: boolean | null;
        } | null;
      } | null;
      createdBy?: {
        __typename?: 'User';
        _id: string;
        firstName?: string | null;
        lastName?: string | null;
        name?: string | null;
        title?: string | null;
        image?: string | null;
        isTop?: boolean | null;
      } | null;
      searcher?: {
        __typename?: 'User';
        _id: string;
        firstName?: string | null;
        lastName?: string | null;
        name?: string | null;
        title?: string | null;
        image?: string | null;
        isTop?: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};

export type DeleteContactMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;

export type DeleteContactMutation = {
  __typename?: 'Mutation';
  deleteContact?: { __typename?: 'deleteContactOutput'; item?: { __typename?: 'Contact'; _id?: string | null } | null } | null;
};

export type ContactsMissionDirectionQueryVariables = Exact<{
  filter?: InputMaybe<ContactsFilterInput>;
}>;

export type ContactsMissionDirectionQuery = {
  __typename?: 'Query';
  missionContacts?: {
    __typename?: 'ContactMissionList';
    items?: Array<{
      __typename?: 'ContactMission';
      _id?: string | null;
      status?: string | null;
      bountyStart?: number | null;
      bountyConfirm?: number | null;
      missionAcceptedAt?: any | null;
      missionRefusedAt?: any | null;
      rulesAcceptedAt?: any | null;
      rulesRefusedAt?: any | null;
      candidateInProcessAt?: any | null;
      candidateNotInProcessAt?: any | null;
      candidateUnderOfferAt?: any | null;
      candidateNotUnderOfferAt?: any | null;
      candidateOfferAcceptedAt?: any | null;
      candidateOfferRefusedAt?: any | null;
      candidateTrainingStartedAt?: any | null;
      candidateTrainingNotStartedAt?: any | null;
      candidateTrainingConfirmedAt?: any | null;
      candidateTrainingNotConfirmedAt?: any | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      currency?: string | null;
      candidate?: { __typename?: 'Candidate'; _id?: string | null; fullName?: string | null } | null;
      availableProfile?: {
        __typename?: 'AvailableProfile';
        _id: string;
        name?: string | null;
        bounty?: number | null;
        publishedAt?: any | null;
        createdBy?: {
          __typename?: 'User';
          _id: string;
          firstName?: string | null;
          lastName?: string | null;
          name?: string | null;
          title?: string | null;
          image?: string | null;
          isTop?: boolean | null;
        } | null;
      } | null;
      createdBy?: {
        __typename?: 'User';
        _id: string;
        firstName?: string | null;
        lastName?: string | null;
        name?: string | null;
        title?: string | null;
        image?: string | null;
        isTop?: boolean | null;
      } | null;
      searcher?: {
        __typename?: 'User';
        _id: string;
        firstName?: string | null;
        lastName?: string | null;
        name?: string | null;
        title?: string | null;
        image?: string | null;
        isTop?: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};

export type DeleteContactMissionMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;

export type DeleteContactMissionMutation = {
  __typename?: 'Mutation';
  deleteContactMission?: { __typename?: 'deleteContactMissionOutput'; item?: { __typename?: 'ContactMission'; _id?: string | null } | null } | null;
};

export type CreateAvailableProfileMutationVariables = Exact<{
  input: CreateAvailableProfileInput;
}>;

export type CreateAvailableProfileMutation = {
  __typename?: 'Mutation';
  createAvailableProfile?: {
    __typename?: 'createAvailableProfileOutput';
    item?: { __typename?: 'AvailableProfile'; _id: string; name?: string | null } | null;
  } | null;
};

export type DeleteAvailableProfileMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;

export type DeleteAvailableProfileMutation = {
  __typename?: 'Mutation';
  deleteAvailableProfile?: {
    __typename?: 'deleteAvailableProfileOutput';
    item?: { __typename?: 'AvailableProfile'; _id: string; name?: string | null } | null;
  } | null;
};

export type PublishAvailableProfileMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  value: Scalars['Boolean']['input'];
}>;

export type PublishAvailableProfileMutation = {
  __typename?: 'Mutation';
  publishAvailableProfile?: {
    __typename?: 'publishAvailableProfileOutput';
    item?: { __typename?: 'AvailableProfile'; _id: string; name?: string | null; publishedAt?: any | null } | null;
  } | null;
};

export type UpdateAvailableProfileMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateAvailableProfileInput;
}>;

export type UpdateAvailableProfileMutation = {
  __typename?: 'Mutation';
  updateAvailableProfile?: {
    __typename?: 'updateAvailableProfileOutput';
    item?: { __typename?: 'AvailableProfile'; _id: string; name?: string | null } | null;
  } | null;
};

export type MyAvailableProfilesQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AvailableProfilesFilterInput>;
}>;

export type MyAvailableProfilesQuery = {
  __typename?: 'Query';
  myAvailableProfiles?: {
    __typename?: 'AvailableProfileList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null } | null;
    items?: Array<{
      __typename?: 'AvailableProfile';
      _id: string;
      name?: string | null;
      bountyDescription?: string | null;
      bounty?: number | null;
      previousBounty?: number | null;
      bountyChangedAt?: any | null;
      sector?: string | null;
      sectorIds?: Array<string | null> | null;
      occupation?: string | null;
      occupationIds?: Array<string | null> | null;
      client?: string | null;
      location?: string | null;
      experience?: string | null;
      description?: string | null;
      context?: string | null;
      publishedAt?: any | null;
      expiresAt?: any | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      countryIds?: Array<string | null> | null;
      currency?: string | null;
      sectors?: Array<{ __typename?: 'Sector'; name?: string | null } | null> | null;
      occupations?: Array<{ __typename?: 'Sector'; name?: string | null } | null> | null;
      baseSalary?: { __typename?: 'AvailableProfileBaseSalary'; min?: number | null; max?: number | null } | null;
      candidate?: {
        __typename?: 'Candidate';
        _id?: string | null;
        resumeUrl?: string | null;
        url?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
      contacts?: Array<{
        __typename?: 'Contact';
        status?: string | null;
        inProcess?: boolean | null;
        contactInitiated?: boolean | null;
        contactStopped?: boolean | null;
        endedProcess?: boolean | null;
        processSucceeded?: boolean | null;
      } | null> | null;
      areaSearch?: {
        __typename?: 'AreaSearch';
        areas?: Array<{
          __typename?: 'Area';
          name?: string | null;
          radius?: number | null;
          geo?: { __typename?: 'Geo'; type?: string | null; coordinates?: Array<number | null> | null } | null;
        } | null> | null;
      } | null;
      matchings?: Array<{
        __typename?: 'Matching';
        _id: string;
        viewedAt?: any | null;
        searchedProfileId: string;
        fromAvailableProfile?: boolean | null;
        fromSearchedProfile?: boolean | null;
        score?: number | null;
        searchedProfile?: {
          __typename?: 'SearchedProfile';
          _id: string;
          name?: string | null;
          bounty?: number | null;
          currency?: string | null;
          experience?: string | null;
          publishedAt?: any | null;
          sectorIds?: Array<string | null> | null;
          countryIds?: Array<string | null> | null;
          occupationId?: string | null;
          bountyChangedAt?: any | null;
          previousBounty?: number | null;
          baseSalary?: { __typename?: 'SearchedProfileBaseSalary'; min?: number | null; max?: number | null } | null;
          createdBy?: { __typename?: 'User'; _id: string; name?: string | null; title?: string | null; image?: string | null } | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type CreateCandidateAvailableProfileMutationVariables = Exact<{
  input: CreateCandidateInput;
}>;

export type CreateCandidateAvailableProfileMutation = {
  __typename?: 'Mutation';
  createCandidate?: {
    __typename?: 'createCandidateOutput';
    item?: {
      __typename?: 'Candidate';
      _id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      fullName?: string | null;
      resumeUrl?: string | null;
      url?: string | null;
      createdAt?: any | null;
    } | null;
  } | null;
};

export type CreateSearchedProfileMutationVariables = Exact<{
  input: CreateSearchedProfileInput;
}>;

export type CreateSearchedProfileMutation = {
  __typename?: 'Mutation';
  createSearchedProfile?: {
    __typename?: 'createSearchedProfileOutput';
    item?: { __typename?: 'SearchedProfile'; _id: string; name?: string | null } | null;
  } | null;
};

export type DeleteSearchedProfileMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;

export type DeleteSearchedProfileMutation = {
  __typename?: 'Mutation';
  deleteSearchedProfile?: {
    __typename?: 'deleteSearchedProfileOutput';
    item?: { __typename?: 'SearchedProfile'; _id: string; name?: string | null } | null;
  } | null;
};

export type PublishSearchedProfileMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  value: Scalars['Boolean']['input'];
}>;

export type PublishSearchedProfileMutation = {
  __typename?: 'Mutation';
  publishSearchedProfile?: {
    __typename?: 'publishSearchedProfileOutput';
    item?: { __typename?: 'SearchedProfile'; _id: string; name?: string | null; publishedAt?: any | null } | null;
  } | null;
};

export type GiveExclusivitySearchedProfileMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  value: Scalars['Boolean']['input'];
  sourcingBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type GiveExclusivitySearchedProfileMutation = {
  __typename?: 'Mutation';
  giveExclusivitySearchedProfile?: {
    __typename?: 'giveExclusivitySearchedProfileOutput';
    item?: { __typename?: 'SearchedProfile'; _id: string; name?: string | null; sourcingBy?: string | null; sourcingAt?: any | null } | null;
  } | null;
};

export type UpdateSearchedProfileMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateSearchedProfileInput;
}>;

export type UpdateSearchedProfileMutation = {
  __typename?: 'Mutation';
  updateSearchedProfile?: {
    __typename?: 'updateSearchedProfileOutput';
    item?: { __typename?: 'SearchedProfile'; _id: string; name?: string | null } | null;
  } | null;
};

export type MySearchedProfilesQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchedProfilesFilterInput>;
}>;

export type MySearchedProfilesQuery = {
  __typename?: 'Query';
  mySearchedProfiles?: {
    __typename?: 'SearchedProfileList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null } | null;
    items?: Array<{
      __typename?: 'SearchedProfile';
      _id: string;
      name?: string | null;
      bountyDescription?: string | null;
      bounty?: number | null;
      bountyStart?: number | null;
      bountyConfirm?: number | null;
      previousBounty?: number | null;
      bountyChangedAt?: any | null;
      client?: string | null;
      clientDisclosure?: boolean | null;
      commissionRate?: number | null;
      commissionRateDisclosure?: boolean | null;
      urgent?: boolean | null;
      experience?: string | null;
      context?: string | null;
      descriptionUrl?: string | null;
      sourcingAt?: any | null;
      sourcingBy?: string | null;
      fromPlatform?: string | null;
      description?: string | null;
      sector?: string | null;
      sectorIds?: Array<string | null> | null;
      occupationId?: string | null;
      publishedAt?: any | null;
      expiresAt?: any | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      countryIds?: Array<string | null> | null;
      currency?: string | null;
      nbPositions?: number | null;
      nbPositionsFilled?: number | null;
      baseSalary?: { __typename?: 'SearchedProfileBaseSalary'; min?: number | null; max?: number | null } | null;
      exclusiveSourcer?: {
        __typename?: 'User';
        _id: string;
        firstName?: string | null;
        lastName?: string | null;
        name?: string | null;
        title?: string | null;
        image?: string | null;
      } | null;
      sectors?: Array<{ __typename?: 'Sector'; name?: string | null } | null> | null;
      occupation?: { __typename?: 'Occupation'; name?: string | null } | null;
      contacts?: Array<{
        __typename?: 'Contact';
        status?: string | null;
        inProcess?: boolean | null;
        endedProcess?: boolean | null;
        processSucceeded?: boolean | null;
        processConfirmed?: boolean | null;
        contactInitiated?: boolean | null;
        contactStopped?: boolean | null;
        candidateUnderOfferAt?: any | null;
      } | null> | null;
      sites?: {
        __typename?: 'AreaSearch';
        areas?: Array<{
          __typename?: 'Area';
          name?: string | null;
          radius?: number | null;
          geo?: { __typename?: 'Geo'; type?: string | null; coordinates?: Array<number | null> | null } | null;
        } | null> | null;
      } | null;
      matchings?: Array<{
        __typename?: 'Matching';
        _id: string;
        availableProfileId: string;
        fromAvailableProfile?: boolean | null;
        fromSearchedProfile?: boolean | null;
        score?: number | null;
        viewedAt?: any | null;
        availableProfile?: {
          __typename?: 'AvailableProfile';
          _id: string;
          name?: string | null;
          bounty?: number | null;
          currency?: string | null;
          experience?: string | null;
          publishedAt?: any | null;
          sectorIds?: Array<string | null> | null;
          countryIds?: Array<string | null> | null;
          occupationIds?: Array<string | null> | null;
          bountyChangedAt?: any | null;
          previousBounty?: number | null;
          baseSalary?: { __typename?: 'AvailableProfileBaseSalary'; min?: number | null; max?: number | null } | null;
          createdBy?: { __typename?: 'User'; _id: string; name?: string | null; title?: string | null; image?: string | null } | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;

export type CreateContactMutation = {
  __typename?: 'Mutation';
  createContact?: { __typename?: 'createContactOutput'; item?: { __typename?: 'Contact'; _id?: string | null } | null } | null;
};

export type SearchProfilesQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchedProfilesFilterInput>;
}>;

export type SearchProfilesQuery = {
  __typename?: 'Query';
  searchedProfiles?: {
    __typename?: 'SearchedProfileList';
    pageInfo?: { __typename?: 'PageInfo'; count?: any | null } | null;
    items?: Array<{
      __typename?: 'SearchedProfile';
      _id: string;
      name?: string | null;
      bounty?: number | null;
      bountyStart?: number | null;
      bountyConfirm?: number | null;
      previousBounty?: number | null;
      bountyChangedAt?: any | null;
      sector?: string | null;
      occupationId?: string | null;
      client?: string | null;
      experience?: string | null;
      description?: string | null;
      context?: string | null;
      fromPlatform?: string | null;
      publishedAt?: any | null;
      createdAt?: any | null;
      sourcingAt?: any | null;
      updatedAt?: any | null;
      expiresAt?: any | null;
      countryIds?: Array<string | null> | null;
      currency?: string | null;
      urgent?: boolean | null;
      commissionRate?: number | null;
      nbPositions?: number | null;
      nbPositionsFilled?: number | null;
      completedAt?: any | null;
      sectors?: Array<{ __typename?: 'Sector'; name?: string | null } | null> | null;
      occupation?: { __typename?: 'Occupation'; name?: string | null } | null;
      baseSalary?: { __typename?: 'SearchedProfileBaseSalary'; min?: number | null; max?: number | null } | null;
      createdBy?: {
        __typename?: 'User';
        _id: string;
        firstName?: string | null;
        name?: string | null;
        title?: string | null;
        image?: string | null;
        openToSource?: boolean | null;
        isTop?: boolean | null;
        ambassadorFor?: string | null;
        roles?: Array<string | null> | null;
        onHolidaysUntil?: any | null;
        onHolidays?: boolean | null;
        nbSearchedProfiles?: number | null;
        nbAvailableProfiles?: number | null;
        nbSearchedProfilesPublished?: number | null;
        nbAvailableProfilesPublished?: number | null;
        nbContactsProspecting?: number | null;
        nbContactsSourcing?: number | null;
        nbQualityContactsProspecting?: number | null;
        nbQualityContactsSourcing?: number | null;
        createdAt?: any | null;
        lastLoginAt?: any | null;
        rating?: {
          __typename?: 'UserRating';
          average?: number | null;
          count?: number | null;
          responsiveness?: number | null;
          relevance?: number | null;
          reliability?: number | null;
        } | null;
      } | null;
      contacts?: Array<{
        __typename?: 'Contact';
        status?: string | null;
        inProcess?: boolean | null;
        endedProcess?: boolean | null;
        processSucceeded?: boolean | null;
        processConfirmed?: boolean | null;
        contactInitiated?: boolean | null;
        contactStopped?: boolean | null;
        candidateUnderOfferAt?: any | null;
      } | null> | null;
      sites?: {
        __typename?: 'AreaSearch';
        areas?: Array<{ __typename?: 'Area'; name?: string | null; radius?: number | null } | null> | null;
      } | null;
      myMatchings?: Array<{
        __typename?: 'Matching';
        _id: string;
        viewedAt?: any | null;
        availableProfileUserId: string;
        availableProfileId: string;
        availableProfile?: {
          __typename?: 'AvailableProfile';
          _id: string;
          name?: string | null;
          bounty?: number | null;
          previousBounty?: number | null;
          bountyChangedAt?: any | null;
          currency?: string | null;
          experience?: string | null;
          publishedAt?: any | null;
          sectorIds?: Array<string | null> | null;
          countryIds?: Array<string | null> | null;
          occupationIds?: Array<string | null> | null;
          baseSalary?: { __typename?: 'AvailableProfileBaseSalary'; min?: number | null; max?: number | null } | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export const ContactInvoiceFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContactInvoiceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactInvoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contact' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'from' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'to' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactInvoiceFragmentFragment, unknown>;
export const AdminEventFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AdminEventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminEventFieldsFragment, unknown>;
export const EventFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nbMaxParticipants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventFieldsFragment, unknown>;
export const ContactFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContactFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchedProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bountyStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bountyConfirm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bountyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourcingAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourcingBy' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exclusiveSourcer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bountyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'candidate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searcher' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'events' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'bountyStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bountyConfirm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateAcceptedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateRefusedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rulesAcceptedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rulesRefusedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rulesRefusedFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateRefusedFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateInProcessAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateNotInProcessAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateUnderOfferAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateNotUnderOfferAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateOfferAcceptedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateOfferRefusedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingNotStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingConfirmedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingNotConfirmedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingStartPotentialDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingConfirmedPotentialDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processSucceededAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shouldAnswerBefore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactFragmentFragment, unknown>;
export const ChatUserFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openToSource' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChatUserFragmentFragment, unknown>;
export const DiscussionFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DiscussionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Discussion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'senderId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sender' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openToSource' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiscussionFragmentFragment, unknown>;
export const MessageFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'discussionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'editedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'readByIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openToSource' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageFragmentFragment, unknown>;
export const NotificationSearchedProfileFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationSearchedProfileFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchedProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationSearchedProfileFragmentFragment, unknown>;
export const NotificationAvailableProfileFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationAvailableProfileFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AvailableProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationAvailableProfileFragmentFragment, unknown>;
export const NotificationFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Notification' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'objectId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchedProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'NotificationSearchedProfileFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'NotificationAvailableProfileFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationSearchedProfileFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchedProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationAvailableProfileFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AvailableProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationFragmentFragment, unknown>;
export const CompanyUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompanyUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sectors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'geo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinates' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastLoginAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyUserFieldsFragment, unknown>;
export const UserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLocation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sectors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'occupationIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'occupations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyArea' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companySalaryTreated' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                { kind: 'Field', name: { kind: 'Name', value: 'max' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'behaviorGuidelines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyClients' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companySize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'onHolidaysUntil' } },
          { kind: 'Field', name: { kind: 'Name', value: 'onHolidays' } },
          { kind: 'Field', name: { kind: 'Name', value: 'experience' } },
          { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'motivation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'motivation_other' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referrer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referrer_other' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessRegistrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'areaSearch' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'geo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinates' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'zone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skipNewMissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skipNewCandidates' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skipDailyEmail' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'affiliateId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parentUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastLoginAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenSectorsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'seenOccupationsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'seenAreasAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'seenBrowserNotificationsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentToMakeAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'geo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinates' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'certificationIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recruiterToolIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recruiterTools' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasPendingActions' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserFieldsFragment, unknown>;
export const BannerMySearchedProfilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BannerMySearchedProfiles' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mySearchedProfiles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BannerMySearchedProfilesQuery, BannerMySearchedProfilesQueryVariables>;
export const BannerMyAvailableProfilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BannerMyAvailableProfiles' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myAvailableProfiles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BannerMyAvailableProfilesQuery, BannerMyAvailableProfilesQueryVariables>;
export const ViewMatchingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'viewMatching' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewMatching' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: '_id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewMatchingMutation, ViewMatchingMutationVariables>;
export const RejectMatchingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'rejectMatching' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rejectMatching' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: '_id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RejectMatchingMutation, RejectMatchingMutationVariables>;
export const RecruitersListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RecruitersList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recruiters' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sectors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupationIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'occupations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyArea' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companySalaryTreated' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'areaSearch' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'areas' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'geo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'coordinates' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'locations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'areas' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'geo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'coordinates' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyClients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companySize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'businessRegistrationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'openToSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbSearchedProfiles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbAvailableProfiles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbSearchedProfilesPublished' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbAvailableProfilesPublished' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbContactsProspecting' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbContactsSourcing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbQualityContactsProspecting' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbQualityContactsSourcing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastLoginAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recruiterTools' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecruitersListQuery, RecruitersListQueryVariables>;
export const AcceptRejectContactCandidateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'acceptRejectContactCandidate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'acceptRejectContactCandidateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acceptRejectContactCandidate' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shouldAnswerBefore' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcceptRejectContactCandidateMutation, AcceptRejectContactCandidateMutationVariables>;
export const AffiliateUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AffiliateUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AffiliateUsersFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliateUsers' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'affiliateId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parentAffiliateId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyLocation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sectors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'occupationIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'occupations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyArea' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companySalaryTreated' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'areaSearch' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'areas' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyClients' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companySize' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'businessRegistrationId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'openToSource' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'onHolidaysUntil' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'onHolidays' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AffiliateUsersQuery, AffiliateUsersQueryVariables>;
export const AvailableProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'availableProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableProfile' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountySearcher' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyFinder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'platformFees' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sectors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'occupations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupationIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'client' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'experience' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'baseSalary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'context' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'areaSearch' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'areas' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvailableProfileQuery, AvailableProfileQueryVariables>;
export const AcceptOfferContactCandidateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'acceptOfferContactCandidate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'acceptOfferContactCandidateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acceptOfferContactCandidate' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingStartPotentialDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shouldAnswerBefore' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcceptOfferContactCandidateMutation, AcceptOfferContactCandidateMutationVariables>;
export const ConfirmTrainingContactCandidateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'confirmTrainingContactCandidate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'confirmTrainingContactCandidateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'confirmTrainingContactCandidate' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invoiceConfirmWithCandidateId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invoiceConfirmWithMissionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingStartPotentialDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingConfirmedPotentialDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shouldAnswerBefore' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConfirmTrainingContactCandidateMutation, ConfirmTrainingContactCandidateMutationVariables>;
export const InProcessContactCandidateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'inProcessContactCandidate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'inProcessContactCandidateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inProcessContactCandidate' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shouldAnswerBefore' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InProcessContactCandidateMutation, InProcessContactCandidateMutationVariables>;
export const StartTrainingContactCandidateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'startTrainingContactCandidate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'startTrainingContactCandidateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrainingContactCandidate' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invoiceStartWithCandidateId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invoiceStartWithMissionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingStartPotentialDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingConfirmedPotentialDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shouldAnswerBefore' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StartTrainingContactCandidateMutation, StartTrainingContactCandidateMutationVariables>;
export const UnderOfferContactCandidateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'underOfferContactCandidate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'underOfferContactCandidateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'underOfferContactCandidate' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shouldAnswerBefore' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingStartPotentialDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnderOfferContactCandidateMutation, UnderOfferContactCandidateMutationVariables>;
export const ContactInvoiceListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactInvoiceList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactInvoicesFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myContactInvoices' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: '-updatedAt', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContactInvoiceFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContactInvoiceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactInvoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contact' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'from' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'to' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactInvoiceListQuery, ContactInvoiceListQueryVariables>;
export const DiscoverContactCandidateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'discoverContactCandidate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'discoverContactCandidateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discoverContactCandidate' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shouldAnswerBefore' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'candidate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resumeUrl' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiscoverContactCandidateMutation, DiscoverContactCandidateMutationVariables>;
export const DiscoverContactMissionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'discoverContactMission' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'discoverContactMissionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discoverContactMission' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shouldAnswerBefore' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'candidate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resumeUrl' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiscoverContactMissionMutation, DiscoverContactMissionMutationVariables>;
export const EventCalendarDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EventCalendar' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'events' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: '-updatedAt', block: false } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AdminEventFields' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AdminEventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventCalendarQuery, EventCalendarQueryVariables>;
export const InformContactCandidateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'informContactCandidate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'informContactCandidateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'informContactCandidate' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InformContactCandidateMutation, InformContactCandidateMutationVariables>;
export const MemberDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'member' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'member' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyArea' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companySalaryTreated' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyClients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companySize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'businessRegistrationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'behaviorGuidelines' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbAvailableProfiles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbAvailableProfilesPublished' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbSearchedProfiles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbSearchedProfilesPublished' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbContactsProspecting' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbContactsSourcing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbQualityContactsProspecting' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbQualityContactsSourcing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastLoginAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onHolidaysUntil' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onHolidays' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MemberQuery, MemberQueryVariables>;
export const MemberListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MemberList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'members' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sectors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupationIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'occupations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyArea' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companySalaryTreated' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'areaSearch' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'areas' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'geo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'coordinates' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'locations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'areas' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'geo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'coordinates' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyClients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companySize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'businessRegistrationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'openToSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbSearchedProfiles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbAvailableProfiles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbSearchedProfilesPublished' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbAvailableProfilesPublished' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbContactsProspecting' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbContactsSourcing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbQualityContactsProspecting' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbQualityContactsSourcing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastLoginAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onHolidaysUntil' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onHolidays' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recruiterToolIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recruiterTools' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rating' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'average' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'responsiveness' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'relevance' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reliability' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MemberListQuery, MemberListQueryVariables>;
export const ProposeContactCandidateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'proposeContactCandidate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'proposeContactCandidateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'proposeContactCandidate' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shouldAnswerBefore' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'candidate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProposeContactCandidateMutation, ProposeContactCandidateMutationVariables>;
export const ProposeCandidateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProposeCandidate' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'candidates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProposeCandidateQuery, ProposeCandidateQueryVariables>;
export const ProposeContactMissionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'proposeContactMission' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'proposeContactMissionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'proposeContactMission' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyConfirm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'platformFees' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shouldAnswerBefore' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProposeContactMissionMutation, ProposeContactMissionMutationVariables>;
export const SearchedProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchedProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchedProfile' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyConfirm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'platformFees' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sectors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupationId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'occupation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'client' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'experience' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'baseSalary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'descriptionUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'context' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromPlatform' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourcingAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourcingBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sites' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'areas' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'urgent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commissionRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbPositions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbPositionsFilled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchedProfileQuery, SearchedProfileQueryVariables>;
export const SelectCandidateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SelectCandidate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'q' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'items' },
            name: { kind: 'Name', value: 'candidates' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: '-_id', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1000' } },
              { kind: 'Argument', name: { kind: 'Name', value: 'q' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'q' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resumeUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SelectCandidateQuery, SelectCandidateQueryVariables>;
export const SelectMemberDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SelectMember' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'members' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SelectMemberQuery, SelectMemberQueryVariables>;
export const OccupationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Occupations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'q' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'items' },
            name: { kind: 'Name', value: 'occupations' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: 'name', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'q' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'q' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OccupationsQuery, OccupationsQueryVariables>;
export const SectorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Sectors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'q' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'items' },
            name: { kind: 'Name', value: 'sectors' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: 'name', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'q' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'q' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SectorsQuery, SectorsQueryVariables>;
export const SelectToolDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SelectTool' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'q' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'items' },
            name: { kind: 'Name', value: 'tools' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: 'name', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'q' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'q' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SelectToolQuery, SelectToolQueryVariables>;
export const UpdateToolDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateTool' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'updateToolInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTool' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbMaxParticipants' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priceType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateToolMutation, UpdateToolMutationVariables>;
export const CreateToolDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createTool' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createToolInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTool' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbMaxParticipants' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priceType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateToolMutation, CreateToolMutationVariables>;
export const UpdateAafInvoiceContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAAFInvoiceContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'updateAAFInvoiceContactInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAAFInvoiceContact' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aafStartUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aafConfirmUrl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAafInvoiceContactMutation, UpdateAafInvoiceContactMutationVariables>;
export const AdminContactInvoiceListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminContactInvoiceList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactInvoicesFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInvoices' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: '-updatedAt', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contact' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'from' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'to' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminContactInvoiceListQuery, AdminContactInvoiceListQueryVariables>;
export const AdminEventCalendarDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminEventCalendar' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'events' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: '-updatedAt', block: false } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFields' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nbMaxParticipants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminEventCalendarQuery, AdminEventCalendarQueryVariables>;
export const CreateEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createEventInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEvent' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFields' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nbMaxParticipants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateEventMutation, CreateEventMutationVariables>;
export const UpdateEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'updateEventInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEvent' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFields' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nbMaxParticipants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEventMutation, UpdateEventMutationVariables>;
export const DeleteEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteEvent' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFields' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nbMaxParticipants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteEventMutation, DeleteEventMutationVariables>;
export const AdminToolListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminToolList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ToolsFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tools' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: '-updatedAt', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbMaxParticipants' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priceType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminToolListQuery, AdminToolListQueryVariables>;
export const DeleteToolDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteTool' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTool' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'authorUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbMaxParticipants' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priceType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteToolMutation, DeleteToolMutationVariables>;
export const UseContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UseContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactsFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: '-updatedAt', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContactFragment' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContactFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchedProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bountyStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bountyConfirm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bountyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourcingAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourcingBy' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exclusiveSourcer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bountyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'candidate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searcher' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'events' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'bountyStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bountyConfirm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateAcceptedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateRefusedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rulesAcceptedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rulesRefusedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rulesRefusedFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateRefusedFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateInProcessAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateNotInProcessAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateUnderOfferAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateNotUnderOfferAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateOfferAcceptedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateOfferRefusedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingNotStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingConfirmedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingNotConfirmedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingStartPotentialDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingConfirmedPotentialDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processSucceededAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shouldAnswerBefore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UseContactQuery, UseContactQueryVariables>;
export const UpdateContactStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateContactStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'updateContactStatusInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateContactStatus' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContactFragment' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContactFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchedProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bountyStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bountyConfirm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bountyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourcingAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourcingBy' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exclusiveSourcer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bountyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'candidate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searcher' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'events' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'bountyStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bountyConfirm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateAcceptedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateRefusedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rulesAcceptedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rulesRefusedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rulesRefusedFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateRefusedFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateInProcessAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateNotInProcessAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateUnderOfferAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateNotUnderOfferAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateOfferAcceptedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateOfferRefusedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingNotStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingConfirmedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingNotConfirmedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingStartPotentialDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingConfirmedPotentialDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processSucceededAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shouldAnswerBefore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateContactStatusMutation, UpdateContactStatusMutationVariables>;
export const ImpersonateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'impersonateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'impersonateUserInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'impersonateUser' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImpersonateUserMutation, ImpersonateUserMutationVariables>;
export const ParticipateEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ParticipateEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createEventParticipantInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEventParticipant' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'paymentLink' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'eventParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ParticipateEventMutation, ParticipateEventMutationVariables>;
export const UpdateParticipationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateParticipation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'updateEventParticipantInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEventParticipant' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: '_id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateParticipationMutation, UpdateParticipationMutationVariables>;
export const UpdateInvoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateInvoice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'updateInvoiceInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateInvoice' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'from' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'to' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contact' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;
export const CreateInvoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createInvoice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createInvoiceInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createInvoice' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'from' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'to' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contact' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateInvoiceMutation, CreateInvoiceMutationVariables>;
export const InvoiceListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InvoiceList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'InvoicesFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myInvoices' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: '-updatedAt', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'from' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'to' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contact' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InvoiceListQuery, InvoiceListQueryVariables>;
export const UpdateMyInvoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateMyInvoice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'updateMyInvoiceInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMyInvoice' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'to' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMyInvoiceMutation, UpdateMyInvoiceMutationVariables>;
export const AdminInvoiceListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminInvoiceList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'InvoicesFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'invoices' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: '-updatedAt', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'from' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'to' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contact' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminInvoiceListQuery, AdminInvoiceListQueryVariables>;
export const DuplicateInvoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'duplicateInvoice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'duplicateInvoice' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'userIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'from' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'to' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contact' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DuplicateInvoiceMutation, DuplicateInvoiceMutationVariables>;
export const DeleteInvoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteInvoice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteInvoice' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'from' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'to' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contact' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;
export const MySubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MySubscription' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mySubscription' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'plans' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'validUntil' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MySubscriptionQuery, MySubscriptionQueryVariables>;
export const CreateSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createSubscriptionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSubscription' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const DeleteSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'deleteSubscriptionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteSubscription' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>;
export const GetBillingPortalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GetBillingPortal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'getBillingPortalInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBillingPortal' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBillingPortalMutation, GetBillingPortalMutationVariables>;
export const CreateProspectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createProspect' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createProspectInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createProspect' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mission' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateProspectMutation, CreateProspectMutationVariables>;
export const UpdateProspectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateProspect' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'updateProspectInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProspect' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mission' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateProspectMutation, UpdateProspectMutationVariables>;
export const SelectUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SelectUser' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: '-_id', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1000' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SelectUserQuery, SelectUserQueryVariables>;
export const SelectUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SelectUsers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: '-_id', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1000' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SelectUsersQuery, SelectUsersQueryVariables>;
export const UseChatDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UseChat' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DiscussionsFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myDiscussions' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: '-updatedAt', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DiscussionFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openToSource' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DiscussionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Discussion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'senderId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sender' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UseChatQuery, UseChatQueryVariables>;
export const GetDiscussionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDiscussion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discussionAndConnection' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discussion' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DiscussionFragment' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'connection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openToSource' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DiscussionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Discussion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'senderId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sender' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDiscussionQuery, GetDiscussionQueryVariables>;
export const CreateDiscussionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createDiscussion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateDiscussionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDiscussion' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DiscussionFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openToSource' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DiscussionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Discussion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'senderId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sender' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateDiscussionMutation, CreateDiscussionMutationVariables>;
export const ListMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MessagesFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: 'createdAt', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MessageFragment' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openToSource' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'discussionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'editedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'readByIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListMessagesQuery, ListMessagesQueryVariables>;
export const CreateMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateMessageInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMessage' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MessageFragment' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openToSource' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'discussionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'editedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'readByIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateMessageMutation, CreateMessageMutationVariables>;
export const MarkMessageAsReadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'markMessageAsRead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarkMessageAsReadInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markMessageAsRead' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkMessageAsReadMutation, MarkMessageAsReadMutationVariables>;
export const GetUnreadCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUnreadCount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unreadCount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discussions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DiscussionFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalUnread' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openToSource' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DiscussionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Discussion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'senderId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sender' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatUserFragment' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUnreadCountQuery, GetUnreadCountQueryVariables>;
export const NotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Notifications' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'NotificationsFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myNotifications' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'StringValue', value: '-updatedAt', block: false } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'NotificationFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationSearchedProfileFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchedProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationAvailableProfileFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AvailableProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Notification' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'objectId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchedProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'NotificationSearchedProfileFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'NotificationAvailableProfileFragment' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationsQuery, NotificationsQueryVariables>;
export const UpdateNotificationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateNotification' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'updateNotificationInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNotification' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'NotificationFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationSearchedProfileFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchedProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationAvailableProfileFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AvailableProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Notification' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'objectId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchedProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'NotificationSearchedProfileFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'NotificationAvailableProfileFragment' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const AdminCompaniesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminCompanies' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CompanyUserFields' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompanyUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sectors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'geo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinates' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastLoginAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminCompaniesQuery, AdminCompaniesQueryVariables>;
export const UpdateCompanyUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCompanyUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'updateUserInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CompanyUserFields' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompanyUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sectors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'geo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinates' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastLoginAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCompanyUserMutation, UpdateCompanyUserMutationVariables>;
export const ProspectsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Prospects' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prospects' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mission' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProspectsQuery, ProspectsQueryVariables>;
export const AdminUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NonNegativeInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLocation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sectors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'occupationIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'occupations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyArea' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companySalaryTreated' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                { kind: 'Field', name: { kind: 'Name', value: 'max' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'behaviorGuidelines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyClients' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companySize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'onHolidaysUntil' } },
          { kind: 'Field', name: { kind: 'Name', value: 'onHolidays' } },
          { kind: 'Field', name: { kind: 'Name', value: 'experience' } },
          { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'motivation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'motivation_other' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referrer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referrer_other' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessRegistrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'areaSearch' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'geo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinates' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'zone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skipNewMissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skipNewCandidates' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skipDailyEmail' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'affiliateId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parentUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastLoginAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenSectorsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'seenOccupationsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'seenAreasAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'seenBrowserNotificationsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentToMakeAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'geo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinates' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'certificationIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recruiterToolIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recruiterTools' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasPendingActions' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminUsersQuery, AdminUsersQueryVariables>;
export const UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'updateUserInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLocation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sectors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'occupationIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'occupations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyArea' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companySalaryTreated' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                { kind: 'Field', name: { kind: 'Name', value: 'max' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'behaviorGuidelines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyClients' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companySize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'onHolidaysUntil' } },
          { kind: 'Field', name: { kind: 'Name', value: 'onHolidays' } },
          { kind: 'Field', name: { kind: 'Name', value: 'experience' } },
          { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'motivation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'motivation_other' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referrer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referrer_other' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessRegistrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'areaSearch' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'geo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinates' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'zone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skipNewMissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skipNewCandidates' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skipDailyEmail' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'affiliateId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parentUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastLoginAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenSectorsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'seenOccupationsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'seenAreasAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'seenBrowserNotificationsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentToMakeAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'geo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinates' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'certificationIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recruiterToolIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recruiterTools' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasPendingActions' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const GrantRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'grantRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'grantRoleInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'grantRole' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GrantRoleMutation, GrantRoleMutationVariables>;
export const RemoveRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'removeRoleInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeRole' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveRoleMutation, RemoveRoleMutationVariables>;
export const ArchiveUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'archiveUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'archiveUserInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveUser' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArchiveUserMutation, ArchiveUserMutationVariables>;
export const UnarchiveUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'unarchiveUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'archiveUserInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unarchiveUser' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnarchiveUserMutation, UnarchiveUserMutationVariables>;
export const SetParentAffiliateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setParentAffiliate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'setParentAffiliateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setParentAffiliate' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetParentAffiliateMutation, SetParentAffiliateMutationVariables>;
export const CreateContactMissionAvailableProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateContactMissionAvailableProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createContactMissionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createContactMission' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: '_id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateContactMissionAvailableProfileMutation, CreateContactMissionAvailableProfileMutationVariables>;
export const AvailableProfilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AvailableProfiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AvailableProfilesFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableProfiles' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1000' } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previousBounty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyChangedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupationIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'job' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'client' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'experience' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'baseSalary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'context' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rating' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'average' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'responsiveness' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'relevance' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'reliability' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contacts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'inProcess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endedProcess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'processSucceeded' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'processConfirmed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contactStopped' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'candidateUnderOfferAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contactInitiated' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'myMatchings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'viewedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'searchedProfileUserId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'searchedProfileId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'searchedProfile' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'previousBounty' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bountyChangedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'baseSalary' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'experience' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'occupationId' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'areaSearch' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'areas' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sectors' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvailableProfilesQuery, AvailableProfilesQueryVariables>;
export const CreateCandidateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCandidate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createCandidateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCandidate' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resumeUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCandidateMutation, CreateCandidateMutationVariables>;
export const DeleteCandidateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteCandidate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCandidate' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: '_id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCandidateMutation, DeleteCandidateMutationVariables>;
export const UpdateCandidateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCandidate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'updateCandidateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCandidate' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resumeUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCandidateMutation, UpdateCandidateMutationVariables>;
export const CandidatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Candidates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'candidates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resumeUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availableProfiles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CandidatesQuery, CandidatesQueryVariables>;
export const CreateContactDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateContactDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createContactInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createContact' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: '_id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateContactDetailMutation, CreateContactDetailMutationVariables>;
export const UpdateContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'updateContactInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateContact' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shouldAnswerBefore' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingStartPotentialDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingConfirmedPotentialDate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateContactMutation, UpdateContactMutationVariables>;
export const CreateContactMissionDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateContactMissionDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createContactMissionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createContactMission' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: '_id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateContactMissionDetailMutation, CreateContactMissionDetailMutationVariables>;
export const ContactsDirectionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactsDirection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactsFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'candidateContacts' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'candidate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'searchedProfile' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bountyStart' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bountyConfirm' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'searcher' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyConfirm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateAcceptedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateRefusedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rulesAcceptedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rulesRefusedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateInProcessAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateNotInProcessAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateUnderOfferAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateNotUnderOfferAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateOfferAcceptedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateOfferRefusedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingNotStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingConfirmedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingNotConfirmedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactsDirectionQuery, ContactsDirectionQueryVariables>;
export const DeleteContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteContact' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: '_id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteContactMutation, DeleteContactMutationVariables>;
export const ContactsMissionDirectionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactsMissionDirection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactsFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'missionContacts' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'candidate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availableProfile' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'searcher' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyConfirm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'missionAcceptedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'missionRefusedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rulesAcceptedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rulesRefusedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateInProcessAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateNotInProcessAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateUnderOfferAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateNotUnderOfferAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateOfferAcceptedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateOfferRefusedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingNotStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingConfirmedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'candidateTrainingNotConfirmedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactsMissionDirectionQuery, ContactsMissionDirectionQueryVariables>;
export const DeleteContactMissionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteContactMission' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteContactMission' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: '_id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteContactMissionMutation, DeleteContactMissionMutationVariables>;
export const CreateAvailableProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createAvailableProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createAvailableProfileInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAvailableProfile' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateAvailableProfileMutation, CreateAvailableProfileMutationVariables>;
export const DeleteAvailableProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteAvailableProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAvailableProfile' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteAvailableProfileMutation, DeleteAvailableProfileMutationVariables>;
export const PublishAvailableProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'publishAvailableProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishAvailableProfile' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'value' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'value' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublishAvailableProfileMutation, PublishAvailableProfileMutationVariables>;
export const UpdateAvailableProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAvailableProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'updateAvailableProfileInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAvailableProfile' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAvailableProfileMutation, UpdateAvailableProfileMutationVariables>;
export const MyAvailableProfilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'myAvailableProfiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AvailableProfilesFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myAvailableProfiles' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previousBounty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyChangedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sectors' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupationIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'occupations' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'client' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'experience' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'baseSalary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'candidate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resumeUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'context' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contacts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'inProcess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contactInitiated' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contactStopped' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endedProcess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'processSucceeded' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'areaSearch' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'areas' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'geo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'coordinates' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'viewedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'searchedProfileId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'searchedProfile' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'baseSalary' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'experience' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdBy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'occupationId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bountyChangedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'previousBounty' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'fromAvailableProfile' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fromSearchedProfile' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MyAvailableProfilesQuery, MyAvailableProfilesQueryVariables>;
export const CreateCandidateAvailableProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCandidateAvailableProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createCandidateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCandidate' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resumeUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCandidateAvailableProfileMutation, CreateCandidateAvailableProfileMutationVariables>;
export const CreateSearchedProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createSearchedProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createSearchedProfileInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSearchedProfile' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSearchedProfileMutation, CreateSearchedProfileMutationVariables>;
export const DeleteSearchedProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteSearchedProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteSearchedProfile' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteSearchedProfileMutation, DeleteSearchedProfileMutationVariables>;
export const PublishSearchedProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'publishSearchedProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishSearchedProfile' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'value' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'value' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublishSearchedProfileMutation, PublishSearchedProfileMutationVariables>;
export const GiveExclusivitySearchedProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'giveExclusivitySearchedProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourcingBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'giveExclusivitySearchedProfile' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'value' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'value' } } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourcingBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourcingBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourcingBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourcingAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GiveExclusivitySearchedProfileMutation, GiveExclusivitySearchedProfileMutationVariables>;
export const UpdateSearchedProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateSearchedProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: '_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'updateSearchedProfileInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSearchedProfile' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: '_id' }, value: { kind: 'Variable', name: { kind: 'Name', value: '_id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSearchedProfileMutation, UpdateSearchedProfileMutationVariables>;
export const MySearchedProfilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'mySearchedProfiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchedProfilesFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mySearchedProfiles' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyConfirm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previousBounty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyChangedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'client' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientDisclosure' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commissionRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commissionRateDisclosure' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'urgent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'experience' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'baseSalary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'context' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'descriptionUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourcingAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourcingBy' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exclusiveSourcer' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromPlatform' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sectors' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupationId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'occupation' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contacts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'inProcess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endedProcess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'processSucceeded' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'processConfirmed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contactInitiated' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contactStopped' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'candidateUnderOfferAt' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sites' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'areas' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'geo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'coordinates' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'availableProfileId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'availableProfile' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'baseSalary' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'experience' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdBy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'occupationIds' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bountyChangedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'previousBounty' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'fromAvailableProfile' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fromSearchedProfile' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'viewedAt' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbPositions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbPositionsFilled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MySearchedProfilesQuery, MySearchedProfilesQueryVariables>;
export const CreateContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createContactInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createContact' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: '_id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateContactMutation, CreateContactMutationVariables>;
export const SearchProfilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchProfiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchedProfilesFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchedProfiles' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sort' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1000' } },
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyConfirm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previousBounty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bountyChangedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sectors' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupationId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'occupation' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'client' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'experience' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'baseSalary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'context' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromPlatform' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'openToSource' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isTop' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ambassadorFor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'onHolidaysUntil' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'onHolidays' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nbSearchedProfiles' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nbAvailableProfiles' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nbSearchedProfilesPublished' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nbAvailableProfilesPublished' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nbContactsProspecting' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nbContactsSourcing' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nbQualityContactsProspecting' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nbQualityContactsSourcing' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastLoginAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rating' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'average' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'responsiveness' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'relevance' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'reliability' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourcingAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contacts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'inProcess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endedProcess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'processSucceeded' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'processConfirmed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contactInitiated' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contactStopped' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'candidateUnderOfferAt' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sites' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'areas' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'myMatchings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'viewedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'availableProfileUserId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'availableProfileId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'availableProfile' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bounty' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'previousBounty' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bountyChangedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'baseSalary' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'experience' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sectorIds' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'countryIds' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'occupationIds' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'urgent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commissionRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbPositions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nbPositionsFilled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchProfilesQuery, SearchProfilesQueryVariables>;
